// eslint-disable-next-line no-unused-vars
import React from 'react';
var award = function award(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M187.147 150V50L100.293 0 13.438 50v100l86.855 50 86.854-50z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.438 170c-38.713 0-70-31.287-70-70s31.287-70 70-70c38.714 0 70 31.287 70 70s-31.286 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.28 100c0 36.587 29.565 66.156 66.158 66.156 36.477 0 66.159-29.573 66.159-66.156 0-36.587-29.565-66.156-66.159-66.156-36.593 0-66.158 29.569-66.158 66.156zm-3.841 0c0 38.713 31.286 70 69.999 70 38.592 0 70-31.287 70-70s-31.286-70-70-70c-38.713 0-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.551 52.234h-41.669v-8h49.969v4h-4c4 0 4 .002 4 .005v.06l-.002.132a34.033 34.033 0 0 1-.098 2.07 60.83 60.83 0 0 1-.672 5.6c-.762 4.587-2.292 10.765-5.394 16.991-3.108 6.242-7.835 12.608-15.002 17.405-7.193 4.814-16.606 7.887-28.801 7.887v-8c10.789 0 18.615-2.696 24.351-6.535 5.762-3.856 9.654-9.028 12.291-14.323 2.645-5.311 3.988-10.67 4.663-14.736.154-.931.273-1.789.364-2.556zM38.778 44.234h49.97v8h-41.67c.091.767.21 1.625.365 2.556.675 4.066 2.017 9.425 4.662 14.736 2.637 5.295 6.53 10.467 12.291 14.323 5.736 3.839 13.562 6.535 24.352 6.535v8c-12.196 0-21.608-3.073-28.801-7.887C52.78 85.7 48.053 79.334 44.944 73.092c-3.101-6.226-4.632-12.404-5.393-16.992a60.82 60.82 0 0 1-.673-5.599 43.156 43.156 0 0 1-.098-2.07l-.001-.132v-.06c0-.003 0-.005 4-.005h-4v-4zM92.382 150.231V80.005h16v70.226h-16z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.381 117.314c-19.71 0-35.567-15.919-35.567-35.706V34h71.133v47.608c0 19.787-16.005 35.706-35.566 35.706zM127.549 141.78H73.084c0-4.875 3.937-8.827 8.793-8.827h36.879c4.856.132 8.793 3.952 8.793 8.827z",
    fill: "#FFBF20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.93 38.886H64.535v-5h71.395v5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.815 137.432h-70.87v5.929h70.87v-5.929z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.916 71.705l-2.742-4.777.914-5.328-4.386-3.307-1.279-5.145-5.118-1.102-3.29-4.41-5.3.92-4.569-2.94-4.386 2.572-5.3-.92-3.29 4.41-5.118 1.103-1.096 5.144-4.57 3.491.915 5.512-2.742 4.594 2.742 4.777-.914 5.512 4.386 3.307.914 4.226.183 1.102 4.934 1.103 3.29 4.41 5.3-.92 4.021 2.573.548.367.914-.551 3.655-2.205 5.301.919 3.289-4.41 5.118-1.102.183-1.103.913-3.858 4.387-3.307-.914-5.328 3.107-5.329z",
    fill: "#FFF3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.523 71.756c0 9.498-7.666 17.359-17.29 17.359-9.624 0-17.291-7.697-17.291-17.359 0-9.498 7.667-17.358 17.291-17.358s17.29 7.86 17.29 17.358zM142.769 143.361H57.988V168h84.781v-24.639z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.178 150h-57.4v8h57.4v-8zM107.858 73.732h-3.12l.912-3.984h3.744v-2.76h-3.12l1.008-4.488h-2.976l-1.032 4.488h-4.103l1.007-4.488h-3l-1.007 4.488h-3.72v2.76h3.096l-.888 3.984h-3.72v2.736h3.096l-1.08 4.848h3l1.08-4.848h4.103l-1.104 4.848h3l1.08-4.848h3.744v-2.736zm-6.072.048h-4.175l.911-4.104h4.176l-.912 4.104z",
    fill: "#fff"
  }));
};
award.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var challenge = function challenge(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.438 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.424 0 93 41.699 93 93 .122 51.424-41.576 93-93 93z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.438 175c-41.347 0-75-33.521-75-75 0-41.478 33.522-75 75-75 41.479 0 75 33.522 75 75 0 41.479-33.521 75-75 75z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A016",
    d: "M101.438 81h37v23h-37z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    fill: "#FFCF59",
    d: "M101.438 81h37v23h-37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3A016",
    d: "M55.438 127h83v23h-83zM78.439 104h60v23h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    fill: "#FFBF20",
    d: "M78.439 104h60v23h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.438 64l-13-3-12.333 3-12.667-3.138V36l12.5 3 12.5-3 13 3.138V64z",
    fill: "#FFBF20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.438 36v25l-12.5 3V39l12.5-3z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5320A3",
    d: "M117.438 36h4v45h-4z"
  }));
};
challenge.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var hackathon = function hackathon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.371 192.044c-51.065 0-92.57-41.355-92.57-92.504 0-51.15 41.505-92.504 92.57-92.504 51.185 0 92.569 41.475 92.569 92.504.121 51.149-41.384 92.504-92.569 92.504z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37 174.14c-41.156 0-74.653-33.343-74.653-74.6 0-41.257 33.367-74.6 74.653-74.6 41.287 0 74.654 33.343 74.654 74.6 0 41.257-33.367 74.6-74.654 74.6z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.523 40H22.25c-2.152 0-4.018 1.78-4.018 4.151v61.676h101.165V44.003c0-2.224-1.722-4.003-3.874-4.003z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.153 105.68v4.079l-3.875 3.641c-1.865 1.748-4.305 2.622-6.744 2.622H19.091c-2.44 0-4.879-1.019-6.744-2.622l-3.874-3.641v-4.079h120.68z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.975 105.68H8.438v4.079h120.537v-4.079z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.795 45.879H23.966v59.801h89.829V45.879z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.401 88.055L47.779 76.256l11.623-11.653 2.01 2.04-9.615 9.613 9.614 9.76-2.008 2.04z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.402 88.625l-12.187-12.37 12.188-12.22 2.571 2.61-9.614 9.613 9.612 9.758-2.57 2.61zm-7.606-12.369l9.614-9.614-2.008-2.04-11.623 11.654 11.623 11.8 2.009-2.04-9.615-9.76z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.355 88.055l-2.01-2.039 9.471-9.76-9.47-9.614 2.009-2.04 11.48 11.654-11.48 11.8z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.357 88.627l-2.57-2.609 9.47-9.76-9.472-9.616 2.57-2.61 12.04 12.223-12.038 12.372zm7.46-12.37l-9.47 9.76 2.008 2.038 11.48-11.799-11.48-11.653-2.009 2.04 9.47 9.613z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.328 59.223l-5.865 33.712 2.827.507 5.864-33.712-2.826-.507z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.001 93.258l6.001-34.5 3.614.648-6.001 34.5L64 93.258zm6.326-34.035l2.827.507-5.864 33.712-2.827-.507 5.864-33.712z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.785 59H69.413c-2.34 0-4.367 1.906-4.367 4.448v66.081h109.95v-66.24c0-2.383-1.871-4.289-4.211-4.289z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.599 129.371v4.37l-4.211 3.902c-2.027 1.873-4.679 2.809-7.33 2.809H65.979c-2.65 0-5.302-1.092-7.33-2.809l-4.21-3.902v-4.37h131.16z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.576 129.371H54.463v4.37h131.113v-4.37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.908 65.299h-97.63v64.072h97.63V65.299z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.79 110.488L97.158 97.846 109.79 85.36l2.184 2.185-10.449 10.301 10.449 10.457-2.184 2.185z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.79 111.054l-13.2-13.21 13.202-13.048 2.749 2.751-10.449 10.301 10.447 10.455-2.749 2.751zm-8.266-13.208l10.449-10.3-2.183-2.186-12.633 12.486 12.633 12.642 2.183-2.185-10.449-10.457z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.389 110.488l-2.183-2.185 10.293-10.457-10.293-10.3 2.183-2.186 12.477 12.486-12.477 12.642z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.391 111.056l-2.748-2.751 10.293-10.457-10.295-10.303 2.748-2.75 13.041 13.05-13.039 13.211zm8.108-13.21l-10.293 10.457 2.183 2.185 12.477-12.642-12.477-12.486-2.183 2.185 10.293 10.301z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.665 79.597l-6.373 36.119 3.071.543 6.374-36.12-3.072-.542z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M114.828 116.04l6.513-36.907 3.859.682-6.512 36.907-3.86-.682zm6.837-36.443l3.072.542-6.374 36.12-3.072-.543 6.374-36.12z",
    fill: "#FFCF59"
  }));
};
hackathon.defaultProps = {
  width: "202",
  height: "200",
  viewBox: "0 0 202 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var honor = function honor(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.968 17.001l47.529 14.707 47.408-14.707 11.005 48.741 36.524 33.912-36.524 33.913-11.005 48.741-47.408-14.707-47.53 14.707-11.005-48.741L5.438 99.654l36.524-33.912 11.005-48.741z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.415.001l35.272 38.44 50.594 11.555-15.321 49.995 15.321 49.996-50.594 11.554-35.272 38.441-35.272-38.441-50.705-11.554L29.87 99.991 14.438 49.996l50.705-11.554L100.415 0z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.939",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.484 99.501c0 29.008 23.44 52.452 52.455 52.452 28.92 0 52.454-23.447 52.454-52.452 0-29.008-23.441-52.452-52.454-52.452-29.014 0-52.455 23.444-52.455 52.452zm-3.046 0c0 30.694 24.807 55.5 55.5 55.5 30.598 0 55.5-24.806 55.5-55.5s-24.806-55.5-55.5-55.5c-30.693 0-55.5 24.806-55.5 55.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.17 120.256l4.902 2.64-.943-5.468 3.96-3.771-5.469-.754L64.17 108l-2.452 4.903-5.28.754 3.96 3.96-.943 5.468 4.714-2.829zM138.819 120.256l4.903 2.64-.943-5.468 3.959-3.771-5.468-.754-2.451-4.903-2.451 4.903-5.28.754 3.96 3.96-.943 5.468 4.714-2.829z",
    fill: "#FFBF20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.438 41v60l-35.5 20-35.5-20V41h71z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.438 41v75.112l-8.5 4.888-8.5-4.888V41.001h17z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.439 41v72.5M110.438 41v72.5",
    stroke: "#441E80",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.439 101V41h18v70l-18-10zM137.438 41v60l-17 10V41h17z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.363 168.649l-.634-.387-.732.121-5.641.926-3.54-4.65-.427-.561-.686-.169-5.663-1.395-1.412-5.565-.175-.692-.575-.425-4.702-3.474.933-5.517.124-.728-.38-.634-3.068-5.114 3.046-4.848.405-.645-.127-.752-.933-5.517 4.702-3.474.575-.425.175-.692 1.412-5.565 5.663-1.395.686-.169.428-.561 3.539-4.65 5.641.926.732.121.634-.387 4.957-3.023 5.229 3.044.621.362.71-.117 5.641-.926 3.539 4.65.428.561.686.169 5.663 1.395 1.412 5.565.175.692.575.425 4.702 3.474-.933 5.517-.127.752.405.645 3.046 4.848-3.067 5.114-.38.634.123.728.933 5.517-4.702 3.474-.575.425-.175.692-1.412 5.565-5.663 1.395-.686.169-.428.561-3.539 4.65-5.641-.926-.71-.117-.621.362-5.229 3.044-4.957-3.023z",
    fill: "#fff",
    stroke: "#FFF3D5",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.14 164.836l-.632-.383-.73.119-4.835.791-3.033-3.97-.428-.56-.684-.168-4.853-1.19-1.209-4.745-.176-.693-.576-.424-4.023-2.961.797-4.692.124-.731-.383-.635-2.624-4.359 2.603-4.126.408-.647-.128-.755-.797-4.692 4.023-2.961.576-.424.176-.693 1.209-4.744 4.853-1.191.684-.168.428-.56 3.033-3.969 4.835.791.73.119.631-.384 4.252-2.583 4.489 2.604.62.359.707-.115 4.834-.791 3.033 3.969.428.56.685.168 4.853 1.191 1.208 4.744.177.693.576.424 4.023 2.961-.797 4.692-.128.755.408.647 2.603 4.126-2.625 4.359-.382.635.124.731.797 4.692-4.023 2.961-.576.424-.177.693-1.208 4.745-4.853 1.19-.685.168-.428.56-3.033 3.97-4.834-.791-.707-.116-.62.36-4.489 2.603-4.252-2.583z",
    fill: "#fff",
    stroke: "#F3A016",
    strokeWidth: "4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.825 148.222L110.22 153l-1.588-9.796 6.806-6.929-9.302-1.434-4.311-8.841-4.084 8.841-9.302 1.434 6.806 6.929L93.657 153l8.168-4.778z",
    fill: "#5320A3"
  }));
};
honor.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var paddlGames = function paddlGames(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M187.147 150.167v-100l-86.854-50-86.855 50v100l86.855 50 86.854-50z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.438 170.167c-38.713 0-70-31.287-70-70s31.287-70 70-70c38.714 0 70 31.287 70 70s-31.286 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.28 100.167c0 36.587 29.565 66.156 66.158 66.156 36.477 0 66.159-29.573 66.159-66.156 0-36.587-29.565-66.156-66.159-66.156-36.593 0-66.158 29.569-66.158 66.156zm-3.841 0c0 38.713 31.286 70 69.999 70 38.592 0 70-31.287 70-70s-31.286-70-70-70c-38.713 0-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.368 149.378c-12.919-12.332-21.14-29.832-21.14-49.211 0-15.973 5.52-30.537 14.68-42.165M159.19 66.341c5.756 9.984 8.927 21.494 8.927 33.826 0 37.466-30.42 67.886-67.886 67.886-11.04 0-21.376-2.584-30.537-7.282M67.11 40.855c9.749-5.52 21.141-8.574 33.121-8.574 16.326 0 31.359 5.755 43.104 15.386",
    stroke: "#F3A016",
    strokeWidth: "3.48",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.355 73.047c7.156-13.088 19.496-23.504 35.13-27.693 12.886-3.453 25.828-2.147 37.188 2.73M140.217 140.466c-6.81 6.801-15.41 11.847-25.359 14.513-30.225 8.098-61.34-9.866-69.439-40.091-2.386-8.906-2.536-17.803-.726-26.209M140.873 60.674c6.56 6.67 11.486 15.201 14.076 24.866 3.529 13.17 2.136 26.542-3.095 38.098",
    stroke: "#5320A3",
    strokeWidth: "3.48",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "57.121",
    cy: "47.667",
    r: "2.113",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "61.349",
    cy: "155.803",
    r: "2.113",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "152.871",
    cy: "55.889",
    r: "2.113",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.438 100.167c0 24.075-19.509 44-44 44-24.49 0-44-19.509-44-44 0-24.076 19.51-44 44-44 24.491 0 44 19.924 44 44z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.088 92.851c-2.231-2.282-5.475-3.58-8.646-3.58-3.17 0-6.392 1.3-8.624 3.584l-.002.002c-2.286 2.286-3.585 5.458-3.585 8.626 0 3.222 1.3 6.393 3.585 8.679.97.97 1.947 1.941 2.926 2.914a756.853 756.853 0 0 1 5.697 5.705s.201-.191.276-.266l11.803-11.803.001-.001 5.363-5.416 13.513-13.513a.38.38 0 0 1 .537 0l6.719 6.72c1.632 1.686 2.655 3.752 2.853 6.181.014.164.018.29.022.41l.001.057c.003.099.006.197.013.318v.015c0 2.62-1.067 5.16-2.892 6.985a9.87 9.87 0 0 1-6.985 2.892 9.87 9.87 0 0 1-6.984-2.892l-5.255-5.27a.264.264 0 0 0-.375 0l-4.62 4.619a.259.259 0 0 0 .004.369l.375.375 3.684 3.686 1.229 1.23c1.571 1.571 3.424 2.854 5.459 3.689 2.041.837 4.29 1.307 6.483 1.307 2.198 0 4.444-.418 6.478-1.305l.005-.002a16.851 16.851 0 0 0 5.489-3.659 16.834 16.834 0 0 0 3.658-5.488c.838-2.041 1.308-4.29 1.308-6.483 0-.23-.013-.448-.026-.675l-.001-.003c-.012-.22-.026-.449-.026-.692-.316-3.969-2.094-7.834-4.913-10.654-1.345-1.344-2.688-2.694-4.034-4.045-2.545-2.556-5.096-5.118-7.668-7.662l-.27-.265-.266.267-30.686 30.686a.38.38 0 0 1-.538 0l-3.37-3.371a5.123 5.123 0 0 1-1.512-3.639 5.22 5.22 0 0 1 1.512-3.64 5.177 5.177 0 0 1 3.664-1.505c1.346 0 2.647.547 3.6 1.5l1.923 1.923a.27.27 0 0 0 .38-.002l4.62-4.618a.268.268 0 0 0 .003-.377l-.333-.354a260.772 260.772 0 0 0-1.47-1.459l-.074-.072-.023-.023-.005-.005z",
    fill: "#fff"
  }));
};
paddlGames.defaultProps = {
  width: "201",
  height: "201",
  viewBox: "0 0 201 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var prize = function prize(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.968 17.001l47.529 14.707 47.408-14.707 11.005 48.741 36.524 33.912-36.524 33.913-11.005 48.741-47.408-14.707-47.53 14.707-11.005-48.741L5.438 99.654l36.524-33.912 11.005-48.741z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.415.001l35.272 38.44 50.594 11.555-15.321 49.995 15.321 49.996-50.594 11.554-35.272 38.441-35.272-38.441-50.705-11.554L29.87 99.991 14.438 49.996l50.705-11.554L100.415 0z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.939",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.484 99.501c0 29.008 23.44 52.452 52.455 52.452 28.92 0 52.454-23.447 52.454-52.452 0-29.008-23.441-52.452-52.454-52.452-29.014 0-52.455 23.444-52.455 52.452zm-3.046 0c0 30.694 24.807 55.5 55.5 55.5 30.598 0 55.5-24.806 55.5-55.5s-24.806-55.5-55.5-55.5c-30.693 0-55.5 24.806-55.5 55.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.967 41.204h91.167v117.85H55.967z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.544 92.046l-2.798-4.874.933-5.437-4.476-3.374-1.305-5.25-5.222-1.124-3.356-4.5-5.408.938-4.662-3-4.476 2.625-5.408-.937-3.357 4.499-5.221 1.125-1.119 5.249-4.662 3.562.932 5.624-2.797 4.687 2.797 4.874-.932 5.624 4.475 3.375.933 4.311.186 1.125 5.035 1.125 3.357 4.499 5.408-.937 4.103 2.624.559.375.933-.562 3.729-2.25 5.408.938 3.357-4.5 5.221-1.124.187-1.125.932-3.937 4.476-3.375-.933-5.436 3.171-5.437z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979 92.098c0 9.691-7.822 17.712-17.642 17.712s-17.643-7.853-17.643-17.712c0-9.691 7.823-17.712 17.643-17.712s17.642 8.02 17.642 17.712z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34 96.442l5.659 3.008L106 93.1l4.494-4.511-6.324-.836-2.83-5.68-2.663 5.68-6.158 1.003 4.494 4.511-1.165 6.183 5.492-3.008z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.076 125.47h32.567M91.182 131.576h20.354",
    stroke: "#441E80",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5320A3",
    d: "M48.438 149.217h104v9.838h-104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF20",
    d: "M61.088 149.217v9.838h-5.622v-9.838zM66.708 149.218v9.838h-2.81v-9.839zM141.195 159.055v-9.838h5.622v9.838zM135.574 159.055v-9.838h2.811v9.838z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5320A3",
    d: "M48.438 41.001h104v9.838h-104z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBF20",
    d: "M61.087 41v9.839h-5.622V41zM66.708 41.001v9.838h-2.811v-9.838zM141.195 50.838V41h5.622v9.838zM135.574 50.838V41h2.81v9.838z"
  }));
};
prize.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var tournament = function tournament(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.809 10.443c35.797-4.59 71.462-4.59 107.259 0 18.751 2.36 33.437 17.177 35.928 35.928 4.59 35.797 4.59 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.436-17.177-35.928-35.928-4.589-35.797-4.589-71.462 0-107.26 2.492-18.75 17.178-33.567 35.929-35.927z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100.438 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75 41.479 0 75 33.522 75 75 0 41.479-33.521 75-75 75z",
    fill: "#FFCF59"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.769 162V89h8v73h-8z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.147 146.248H28.77V162h39.378v-15.752zM120.958 146.248H81.579V162h39.379v-15.752zM170.657 146.248h-39.379V162h39.379v-15.752z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.769 126h111v20h-8v-12h-95v12h-8v-20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.769 63.187l-4.48-7.488 1.493-8.612-7.092-5.242-1.866-8.238-8.212-1.872-4.853-6.74-8.585 1.498L99.709 22l-6.346 4.119-8.585-1.498-5.226 7.114-8.212 1.872-1.493 8.238-7.092 5.242 1.493 8.612-4.48 7.488 4.48 7.489-1.493 8.612 7.092 5.242 1.493 6.365.373 1.498 7.839 1.872 5.226 7.114 8.212-1.498 6.345 3.745 1.12.374 1.493-.749 5.973-3.37 8.585 1.498 5.226-7.114 8.212-1.872.373-1.498 1.493-5.99 7.092-5.243-1.493-8.612 3.36-7.863z",
    fill: "#F3A016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.769 63.003c0 15.554-12.445 27.997-28 27.997-15.556 0-28-12.443-28-27.997 0-15.553 12.444-27.996 28-27.996 15.555-.346 28 12.443 28 27.996z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.094 70.563l9.084 5.075-1.747-10.513 7.338-7.25-10.133-1.45L101.094 47l-4.542 9.425-9.783 1.45 7.337 7.612L92.359 76l8.735-5.438z",
    fill: "#FFF3D5"
  }));
};
tournament.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var bachelorDegree = function bachelorDegree(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.709 150V50L99.854 0 13 50v100l86.855 50 86.854-50z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.842 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S33.842 63.413 33.842 100zM30 100c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.782 48.307l4.907 2.485-.958-5.325 3.95-3.787-5.386-.828L99.782 36l-2.393 4.852-5.385.828 3.83 3.787-.838 5.325 4.786-2.485zM122.999 55.052l4.787 2.485-.838-5.325 3.949-3.787-5.504-.828-2.394-4.852-2.513 4.852-5.385.828 3.949 3.787-.957 5.325 4.906-2.485zM76.687 53.632l4.907 2.485-.958-5.325 3.95-3.787-5.505-.828-2.394-4.852-2.393 4.852-5.505.828 3.95 3.787-.958 5.325 4.906-2.485zM141.786 67.477l4.907 2.485-.958-5.325 3.949-3.787-5.504-.828-2.394-4.852-2.513 4.852-5.385.828 3.949 3.787-.957 5.325 4.906-2.485zM57.898 67.477l4.907 2.485-.958-5.325 3.95-3.787-5.505-.828-2.394-4.852-2.393 4.852L50 60.85l3.95 3.787-.958 5.325 4.906-2.485zM99.902 151.693l-4.906-2.485.957 5.325-3.949 3.787 5.385.828L99.902 164l2.394-4.852 5.385-.828-3.83-3.787.838-5.325-4.787 2.485zM76.685 144.948l-4.786-2.485.837 5.325-3.949 3.787 5.505.828 2.393 4.852 2.513-4.852 5.386-.828-3.95-3.787.958-5.325-4.907 2.485zM122.997 146.368l-4.906-2.485.957 5.325-3.949 3.787 5.505.828 2.393 4.852 2.394-4.852 5.505-.828-3.95-3.787.958-5.325-4.907 2.485zM57.898 132.523l-4.906-2.485.957 5.325L50 139.15l5.505.828 2.393 4.852 2.513-4.852 5.385-.828-3.949-3.787.958-5.325-4.907 2.485zM141.786 132.523l-4.906-2.485.957 5.325-3.949 3.787 5.505.828 2.393 4.852 2.394-4.852 5.505-.828-3.95-3.787.958-5.325-4.907 2.485z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.147 77.992v4.147H166v-4.147h4.147zM170.147 84.212v4.147H166v-4.147h4.147zM170.147 90.433v4.146H166v-4.146h4.147zM170.147 96.653v4.147H166v-4.147h4.147zM170.147 102.873v4.147H166v-4.147h4.147zM170.147 109.094v4.147H166v-4.147h4.147z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.832 141.111H52.166l7.972-51.25h77.444l10.25 51.25z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.14 89.86l87.694 51.251-10.413-51.25H60.14zM100 50L18 76.159 60.589 89.86h39.41V50z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 50l82 26.159-42.589 13.702H100V50z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19 124.272a4.636 4.636 0 1 0-.001-9.273 4.636 4.636 0 0 0 .001 9.273z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.269 119.636L159 149.771h18.538l-9.269-30.135z",
    fill: "#441E80"
  }));
};
bachelorDegree.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var certificate = function certificate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.833 10.443c35.796-4.59 71.462-4.59 107.259 0 18.751 2.36 33.437 17.177 35.928 35.928 4.59 35.797 4.59 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.436-17.177-35.928-35.928-4.589-35.797-4.589-71.462 0-107.26 2.492-18.75 17.178-33.567 35.928-35.927z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100.462 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75 41.479 0 75 33.522 75 75 0 41.479-33.521 75-75 75z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.04 47H22.462v106.323H176.04V47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.73 55.984h116.91v2c0 5.479 4.595 10 10.545 10h2v64h-2c-5.95 0-10.545 4.521-10.545 10v2H41.73v-2c0-5.479-4.595-10-10.545-10h-2v-64h2c5.95 0 10.546-4.521 10.546-10v-2zm3.856 4c-.91 6.234-6.014 11.032-12.4 11.87v56.26c6.386.838 11.49 5.635 12.4 11.87h109.198c.909-6.235 6.014-11.032 12.401-11.87v-56.26c-6.387-.838-11.492-5.636-12.401-11.87H45.586z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.879 72.627H75.624v-4h47.255v4z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.599 83.691H57.903v-2.5H140.6v2.5zM152.413 95.505H46.09v-2.5h106.323v2.5zM152.413 107.318H46.09v-2.5h106.323v2.5zM140.599 119.132H57.903v-2.5H140.6v2.5z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.743 131.696H51.185v-4h19.558v4zM148.612 131.696h-19.427v-4h19.427v4z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.462 178v-42h-30v42l15-6.914 15 6.914z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.462 131.411l-2.47-4.276.706-4.99-4.059-3.029-1.059-4.811-4.765-1.247-3-4.098-4.941.713L99.639 107l-4.235 2.673-4.942-.713-3 4.276-4.764 1.069-1.236 4.811-4.058 3.029.706 4.99-2.648 4.276 2.647 4.276-.705 4.989 4.058 3.029 1.236 4.99 2.647.712 2.117.535 3 4.098 4.942-.713L99.639 156l4.235-2.673 4.941.713 3-4.098 2.118-.535 2.647-.712 1.235-4.99 4.059-3.029-.882-4.989 2.47-4.276z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.772 131.411l-2.684 4.646.97 5.485-4.473 3.338-1.347 5.439-3.8 1.024-1.434.362-3.285 4.486-5.401-.779-4.679 2.953-4.68-2.953-5.4.779-3.285-4.486-1.434-.362-3.8-1.024-1.347-5.439-4.436-3.31.77-5.446-2.917-4.713 2.918-4.713-.77-5.446 4.443-3.316 1.364-5.314 5.205-1.168 3.261-4.649 5.429.783 4.679-2.953 4.679 2.953 5.401-.779 3.29 4.494 5.261 1.378 1.162 5.278 4.412 3.293-.775 5.48 2.703 4.679zm-4.78-4.276l.706-4.99-4.059-3.029-1.059-4.811-4.765-1.247-3-4.098-4.941.713L99.639 107l-4.235 2.673-4.941-.713-3 4.276-4.765 1.069-1.235 4.811-4.06 3.029.707 4.99-2.647 4.276 2.647 4.276-.706 4.989 4.059 3.029 1.235 4.99 2.647.712 2.118.535 3 4.098 4.94-.713L99.64 156l4.235-2.673 4.941.713 3-4.098 2.118-.535 2.647-.712 1.235-4.99 4.059-3.029-.882-4.989 2.471-4.276-2.471-4.276z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.504 134.667l1.324 8.333-7.283-4-7.448 4 1.324-8.333-5.959-5.834 8.276-1.333 3.807-7.5 3.642 7.5 8.275 1.333-5.958 5.834z",
    fill: "#A167FF"
  }));
};
certificate.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var course = function course(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M99.537 192.916c-51.064 0-92.57-41.354-92.57-92.504 0-51.15 41.506-92.504 92.57-92.504 51.186 0 92.57 41.476 92.57 92.504.121 51.15-41.384 92.504-92.57 92.504z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.537 175.012c-41.156 0-74.653-33.343-74.653-74.6 0-41.257 33.367-74.6 74.653-74.6 41.287 0 74.654 33.343 74.654 74.6 0 41.257-33.367 74.6-74.654 74.6z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".1",
    d: "M157.662 125.955h-50.23l16.654-74.028h33.576v74.028z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.725 141.932H80.086v10.72h38.639v-10.72z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.617 45.537H29.383c-3.51 0-6.383 2.41-6.383 5.354v86.205c0 2.945 2.872 5.355 6.383 5.355h141.234c3.51 0 6.383-2.41 6.383-5.355V50.891c0-2.945-2.873-5.354-6.383-5.354z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171 51H28v81h143V51z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.514 89.573l-5.418 11.9h28.672V77.921H54.096l5.418 11.652zM140.714 89.82l5.542-11.9H116.56v23.553h29.696l-5.542-11.653z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.939 110.175l-4.73.788-2.957-3.942-4.73-1.182-1.182-4.731-3.942-2.956.788-4.73-2.562-4.336 2.562-4.139-.788-4.73 3.942-2.956 1.182-4.73 4.73-1.183 2.957-3.942 4.73.788 4.139-2.562 4.336 2.563 4.73-.789 2.956 3.942 4.73 1.182 1.183 4.73 3.942 2.957-.789 4.73 2.562 4.139-2.562 4.336.789 4.73-3.942 2.956-1.183 4.731-4.73 1.182-2.956 3.942-4.73-.788-4.336 2.562-4.14-2.562z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.591 68.15l3.904 2.361 4.491-.787 2.733 3.74 4.296.983.976 4.329 3.709 2.755-.781 4.525 2.343 3.936-2.343 3.935.781 4.526-3.709 2.755-.976 4.132-4.296.984-2.733 3.738-4.491-.787-3.904 2.361-3.905-2.361-4.49.787-2.734-3.738-4.1-.984-.976-4.329-3.71-2.755.781-4.526-2.343-3.935 2.343-3.935-.78-4.526 3.709-2.755.976-4.329 4.295-.984 2.734-3.738 4.49.787 3.71-2.165zm0-3.542l-1.562.984-2.929 1.771-3.319-.59-1.757-.197-.976 1.378-1.953 2.754-3.319.787-1.757.394-.586 1.968-.78 3.345-2.734 1.967-1.367.984.196 1.771.585 3.345-1.757 2.952-.976 1.574.976 1.574 1.757 2.952-.585 3.345-.196 1.77 1.367.985 2.734 1.967.78 3.345.39 1.771 1.758.394 3.32.787 1.952 2.755.976 1.377 1.757-.197 3.319-.59 2.928 1.771 1.562.984 1.562-.984 2.929-1.771 3.319.59 1.757.197.976-1.377 1.953-2.755 3.319-.787 1.757-.394.39-1.771.781-3.345 2.734-1.967 1.366-.984-.195-1.771V94.32l1.757-2.952.977-1.574-.977-1.574-1.757-2.755.586-3.345.195-1.771-1.367-.984-2.733-1.968-.976-3.541-.391-1.771-1.757-.394-3.319-.984-1.952-2.754-.976-1.378-1.758.197-3.319.59-2.928-1.77-1.757-.985z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.581 97.123l7.959 4.35-1.505-8.917 6.453-6.307-8.82-1.305-4.087-8.047-3.873 8.047-8.82 1.305 6.454 6.307-1.506 8.917 7.745-4.35z",
    fill: "#4D38E1"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M100 139.792a2.629 2.629 0 0 1-2.655-2.654 2.629 2.629 0 0 1 2.655-2.653 2.629 2.629 0 0 1 2.655 2.653 2.629 2.629 0 0 1-2.655 2.654z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.207 156.428H66.811v-4.205h66.396v4.205z",
    fill: "#441E80"
  }));
};
course.defaultProps = {
  width: "200",
  height: "201",
  viewBox: "0 0 200 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var diploma = function diploma(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.37 10.443c35.797-4.59 71.463-4.59 107.26 0 18.751 2.36 33.437 17.177 35.928 35.928 4.589 35.797 4.589 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.437-17.177-35.928-35.928-4.59-35.797-4.59-71.462 0-107.26 2.491-18.75 17.177-33.567 35.928-35.927z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.894 184.971l21.885-48.231-38.195-17.284-21.745 48.23 23.418-.279 14.637 17.564z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.444 167.407l23.419.279-21.746-48.23-38.194 17.284 21.745 48.231 14.776-17.564z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.16 139.037l-11.29 1.951-7.11-9.618-11.29-2.788-2.788-11.291-9.48-7.109 1.952-11.29-6.133-10.316 6.133-9.897-1.951-11.291 9.479-7.11 2.788-11.29L70.76 46.2l7.11-9.479 11.29 1.952 9.898-6.134 10.315 6.134 11.291-1.952 7.109 9.479 11.291 2.788 2.788 11.29 9.479 7.11-1.952 11.29 6.133 9.898-6.133 10.315 1.952 11.291-9.479 7.109-2.788 11.291-11.291 2.788-7.109 9.479-11.291-1.952-10.315 6.134-9.897-5.994z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.564 36.654l9.338 5.714 10.732-1.951 6.551 8.92 10.313 2.37 2.37 10.313 8.919 6.55-1.811 10.871 5.574 9.478-5.574 9.477 1.811 10.871-8.919 6.551-2.37 9.895-10.313 2.369-6.551 8.92-10.732-1.951-9.338 5.714-9.338-5.714-10.731 1.951-6.55-8.92-9.757-2.369-2.37-10.313-8.92-6.69 1.813-10.871-5.575-9.478 5.575-9.477-1.812-10.593 8.92-6.55 2.37-10.314 10.313-2.369 6.55-8.92 10.732 1.951 8.78-5.435zm0-8.363l-3.763 2.37-6.968 4.181-7.945-1.394-4.18-.418-2.37 3.206-4.739 6.55-7.944 1.951-4.181.976-1.394 4.739-1.812 7.944-6.55 4.739-3.206 2.369.418 4.181 1.394 7.944-4.181 7.108-2.37 3.764 2.37 3.763 4.181 7.108-1.394 7.944-.418 4.181 3.206 2.369 6.55 4.739 1.812 7.944.976 4.182 4.18.975 7.945 1.951 4.739 6.551 2.37 3.345 4.18-.418 7.945-1.394 6.968 4.181 3.763 2.37 3.763-2.37 6.969-4.181 7.944 1.394 4.181.418 2.37-3.345 4.599-6.551 7.944-1.951 4.181-.975.976-4.182 1.812-7.944 6.55-4.739 3.206-2.369-.418-4.181v-7.944l4.181-7.108 2.369-3.763-2.369-3.764-4.181-6.55 1.394-7.944.418-4.181-3.206-2.37-6.55-4.739-2.37-8.501-.975-4.181-4.181-.976-7.945-2.37-4.599-6.69-2.369-3.344-4.182.418-7.944 1.394-6.968-4.182-4.182-2.23z",
    fill: "#AA76FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.853 126.983c21.402 0 38.752-17.35 38.752-38.752S120.255 49.48 98.853 49.48 60.102 66.83 60.102 88.23c0 21.402 17.35 38.752 38.751 38.752z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.459 85.208l10.733 5.855-2.091-11.988 8.643-8.504-11.849-1.812-5.436-10.733-5.158 10.873-11.987 1.672 8.642 8.504-2.091 11.987 10.594-5.854z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.003 100.504h43.54M85.499 108.999h26.548",
    stroke: "#8E57F0",
    strokeWidth: "4",
    strokeMiterlimit: "10"
  }));
};
diploma.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var doctorate = function doctorate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.529 17l47.529 14.708 47.408-14.707 11.006 48.74 36.523 33.913-36.523 33.912-11.006 48.742-47.408-14.708-47.529 14.708-11.005-48.742L5 99.654l36.524-33.912L52.529 17z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.977 0l35.272 38.441 50.594 11.555-15.322 49.995 15.322 49.995-50.594 11.555-35.272 38.44-35.273-38.44L14 149.986l15.432-49.995L14 49.996 64.704 38.44 99.977.001z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.5",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.046 99.5c0 29.009 23.44 52.452 52.454 52.452 28.921 0 52.454-23.446 52.454-52.451 0-29.009-23.44-52.453-52.454-52.453S47.046 70.492 47.046 99.501zM44 99.5c0 30.694 24.806 55.5 55.5 55.5 30.597 0 55.5-24.806 55.5-55.5C155 68.808 130.194 44 99.5 44S44 68.808 44 99.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.94 40.307l4.907 2.485-.957-5.325 3.949-3.787-5.385-.828L99.941 28l-2.394 4.852-5.385.828 3.83 3.787-.838 5.325 4.787-2.485zM123.157 47.052l4.787 2.485-.838-5.325 3.949-3.787-5.505-.828-2.393-4.852-2.513 4.852-5.385.828 3.949 3.787-.957 5.325 4.906-2.485zM76.845 45.632l4.907 2.485-.957-5.325 3.949-3.787-5.505-.828-2.394-4.852-2.393 4.852-5.505.828 3.95 3.787-.958 5.325 4.906-2.485zM141.945 59.477l4.906 2.485-.957-5.325 3.949-3.787-5.505-.828-2.393-4.852-2.514 4.852-5.385.828 3.949 3.787-.957 5.325 4.907-2.485zM58.056 59.477l4.907 2.485-.958-5.325 3.95-3.787-5.505-.828-2.394-4.852-2.393 4.852-5.505.828 3.95 3.787-.958 5.325 4.906-2.485z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.778 167.545C121.752 154.292 110.241 148 96 148H83c-18.788 0-31.5-18-36.041-35.598l1.316-.119C54.5 132 64.93 146.698 83 146.698h13c14.839 0 26.829 6.647 31.974 20.374l-1.196.473z",
    fill: "#441E80",
    stroke: "#441E80",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.197 167.545C79.223 154.292 90.734 148 104.975 148h13c18.788 0 31.5-18 36.041-35.598l-1.316-.119c-6.225 19.717-16.655 34.415-34.725 34.415h-13c-14.84 0-26.829 6.647-31.975 20.374l1.197.473z",
    fill: "#441E80",
    stroke: "#441E80",
    strokeWidth: "1.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.777 114.413l-6.702-1.893c-3.71-1.065-5.864-4.852-4.787-8.52l6.702 1.893c3.71 1.065 5.864 4.852 4.787 8.52z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.46 116.188l6.941.71a7.038 7.038 0 0 0 7.659-6.153l-6.941-.71a7.04 7.04 0 0 0-7.659 6.153zM148.272 128.85l-7.659-4.615c-4.189-2.485-5.505-7.928-2.992-12.07l7.659 4.615c4.188 2.485 5.505 7.928 2.992 12.07zM149.827 125.773l8.736 1.657c4.787.947 9.454-2.248 10.411-7.1l-8.736-1.657c-4.786-.828-9.453 2.249-10.411 7.1zM137.502 139.737l-6.702-7.692a10.152 10.152 0 0 1 .957-14.318l6.702 7.691c3.71 4.26 3.351 10.65-.957 14.319zM142.049 135.713l8.975 4.734c4.906 2.603 11.129.828 13.762-4.142l-8.975-4.733c-4.907-2.604-11.01-.829-13.762 4.141zM120.748 145.18l-3.83-10.413c-2.154-5.799.838-12.189 6.702-14.319l3.829 10.414c2.154 5.798-.837 12.188-6.701 14.318z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.192 145.062l4.667 10.176c2.514 5.562 9.215 8.165 14.839 5.562l-4.667-10.177c-2.513-5.561-9.214-8.046-14.839-5.561zM132.236 142.458l7.061 7.337c3.829 4.023 10.291 4.26 14.36.355l-7.06-7.337c-3.83-4.023-10.292-4.141-14.361-.355zM47.318 114.413l6.701-1.893c3.71-1.065 5.864-4.852 4.787-8.52l-6.821 1.893c-3.59 1.065-5.744 4.852-4.667 8.52z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.514 116.188l-6.94.71a7.038 7.038 0 0 1-7.66-6.153l6.941-.71c3.95-.355 7.3 2.367 7.66 6.153zM52.822 128.85l7.66-4.615c4.188-2.485 5.504-7.928 2.99-12.07l-7.658 4.615c-4.188 2.485-5.505 7.928-2.992 12.07zM51.147 125.773l-8.736 1.657c-4.787.947-9.454-2.248-10.411-7.1l8.736-1.657c4.906-.828 9.573 2.249 10.411 7.1zM63.593 139.737l6.701-7.692a10.152 10.152 0 0 0-.957-14.318l-6.702 7.691c-3.71 4.26-3.35 10.65.958 14.319zM58.926 135.713l-8.976 4.734c-4.906 2.603-11.129.828-13.762-4.142l8.976-4.733c4.906-2.604 11.129-.829 13.762 4.141zM80.227 145.18l3.83-10.413c2.153-5.799-.839-12.189-6.702-14.319l-3.83 10.414c-2.154 5.798.958 12.188 6.702 14.318z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.902 145.062l-4.667 10.176c-2.513 5.562-9.215 8.165-14.839 5.562l4.667-10.177c2.513-5.561 9.215-8.046 14.839-5.561zM68.858 142.458l-7.06 7.337c-3.83 4.023-10.292 4.26-14.36.355l7.06-7.337c3.83-4.023 10.292-4.141 14.36-.355z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.793 126H67.278l4.095-37.517h29.42V126z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.793 126h33.515l-4.095-37.517h-29.42V126zM100.793 79.38V62L39 79.38l32.467 9.103h29.326v-9.104zM100.793 79.38V62l61.793 17.38-32.467 9.103h-29.326v-9.104z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.468 88.483L134.308 126l-4.189-37.517H71.468z",
    fill: "#7B3DED"
  }));
};
doctorate.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var phd = function phd(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.529 17l47.529 14.708 47.408-14.707 11.006 48.74 36.523 33.913-36.523 33.912-11.006 48.742-47.408-14.708-47.529 14.708-11.005-48.742L5 99.654l36.524-33.912L52.529 17z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.977 0l35.272 38.441 50.594 11.555-15.322 49.995 15.322 49.995-50.594 11.555-35.272 38.44-35.273-38.44L14 149.986l15.432-49.995L14 49.996 64.704 38.44 99.977.001z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.5",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.046 99.5c0 29.009 23.44 52.452 52.454 52.452 28.921 0 52.454-23.446 52.454-52.451 0-29.009-23.44-52.453-52.454-52.453S47.046 70.492 47.046 99.501zM44 99.5c0 30.694 24.806 55.5 55.5 55.5 30.597 0 55.5-24.806 55.5-55.5C155 68.808 130.194 44 99.5 44S44 68.808 44 99.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.115 50.007l-8.582 34.33H86.467l-8.582-34.33c10.034-6.338 17.56-16.372 20.597-28.124.924-3.829 1.452-7.79 1.452-11.883 0 4.093.528 8.054 1.452 11.883 3.169 11.752 10.563 21.786 20.729 28.124z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.934 70.737a6.734 6.734 0 1 0 0-13.468 6.734 6.734 0 0 0 0 13.468z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.519 22.28v41.723h-3.037V22.28c0-.396 0-.66.132-.924.924-3.697 1.32-7.394 1.32-11.355 0 3.961.528 7.658 1.321 11.355.132.264.264.528.264.924zM127 97.805H73l13.467-13.6h27.066L127 97.805z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 111.272h54l-13.467 13.468H86.467L73 111.272z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 97.805H73v13.467h54V97.805z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 98H85v66h30V98zM86.863 164.087l13.203 13.204 13.203-13.204H86.863z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 146v3.69L99.925 163 85 149.69V146l14.925 13.178L115 146z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 155v3.719L99.925 172l-8.955-7.969-5.97-5.312V155l14.925 13.281L115 155z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.934 129.757l3.697 1.981-.66-4.093 2.905-2.905-4.093-.66-1.849-3.697-1.848 3.697-4.093.66 3.037 2.905-.66 4.093 3.564-1.981zM99.934 114.177l3.697 1.981-.66-4.093 2.905-2.905-4.093-.66-1.849-3.697-1.848 3.697-4.093.66 3.037 2.905-.66 4.093 3.564-1.981zM99.934 145.338l3.697 1.981-.66-4.094 2.905-2.904-4.093-.661-1.849-3.697-1.848 3.697-4.093.661 3.037 2.904-.66 4.094 3.564-1.981z",
    fill: "#441E80"
  }));
};
phd.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var highSchool = function highSchool(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M99.807 191.972c-51.065 0-92.57-41.355-92.57-92.505 0-51.149 41.505-92.504 92.57-92.504 51.186 0 92.57 41.476 92.57 92.505.121 51.149-41.384 92.504-92.57 92.504z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.807 174.068c-41.157 0-74.653-33.343-74.653-74.6 0-41.258 33.367-74.6 74.653-74.6 41.286 0 74.653 33.342 74.653 74.6 0 41.257-33.367 74.6-74.653 74.6z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27 108h-68v47h68v-47zM168.27 108h-68v47h68v-47z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.544 136.085v7.95h7.95v-7.95h-7.95zM49.943 136.143v7.95h7.95v-7.95h-7.95zM61.343 136.085v7.95h7.95v-7.95h-7.95zM72.742 136.143v7.95h7.95v-7.95h-7.95zM38.5 124.904v7.951h7.95v-7.951H38.5zM49.9 124.963v7.95h7.95v-7.95H49.9zM61.299 124.904v7.951h7.95v-7.951H61.3zM72.698 124.963v7.95h7.95v-7.95h-7.95z",
    fill: "#EADEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.142 136.143v7.95h7.95v-7.95h-7.95zM142.743 136.085v7.95h7.95v-7.95h-7.95zM131.343 136.143v7.95h7.951v-7.95h-7.951z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.944 136.085v7.95h7.95v-7.95h-7.95z",
    fill: "#EADEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.098 124.963v7.95h7.951v-7.95h-7.951zM142.699 124.904v7.951h7.95v-7.951h-7.95zM131.299 124.963v7.95h7.951v-7.95h-7.951z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.9 124.904v7.951h7.95v-7.951h-7.95z",
    fill: "#EADEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.403 155H69.269V69.645L100.27 40",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.403 155h30.867V69.645L100.27 40",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.27 40l31 29.607v85.243l-31 .15",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.77 108c9.665 0 17.5-7.835 17.5-17.5S109.435 73 99.77 73s-17.5 7.835-17.5 17.5 7.835 17.5 17.5 17.5z",
    fill: "#fff",
    stroke: "#C7A4FF",
    strokeWidth: "4",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27 40l-11.334-2.353L111.603 40l-11.333-2.353V19l11.333 2.353L122.936 19l11.334 2.353V40z",
    fill: "#8E57F0"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M122.27 19v18.647l-11 2.353V21.353l11-2.353z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.27 82l39.566-37 39.434 37",
    stroke: "#7B3DED",
    strokeWidth: "10",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.27 85l38.065-36 37.935 35.863",
    stroke: "#441E80",
    strokeWidth: "4",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.584 149H88.932v-19.333c0-5.371 5.08-9.667 11.432-9.667 6.351 0 11.432 4.296 11.432 9.667V149h-.212z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.456 155H67.27v7h66.186v-7z",
    fill: "#8E57F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.236 149H74.49v6h51.746v-6z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.965 82v12l-6.62 5",
    stroke: "#441E80",
    strokeWidth: "3",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
highSchool.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var masterDegree = function masterDegree(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.709 150V50L99.854 0 13 50v100l86.855 50 86.854-50z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.842 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S33.842 63.413 33.842 100zM30 100c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.518 89.558V158l-51.687-8.519v2.644H93.54v-2.644L42 158V89.558h116.518z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.624 89.558v58.602c-20.97-6.756-41.94-1.91-47.552-.294-.295.147-.591.147-.738.294-.148 0-.443-.147-.739-.294-5.759-1.616-26.73-6.316-47.7.44V89.705a68.73 68.73 0 0 1 15.802-3.231c6.203-.588 11.962-.44 16.835 0 7.827.734 13.734 2.35 15.654 2.937 4.43-1.322 26.434-7.05 48.438.147z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.532 86.474L84.53 137l-8.418-3.378L67.548 137V86.474c6.203-.588 11.963-.44 16.984 0z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.111 121.437c7.34 0 13.291-5.918 13.291-13.219 0-7.3-5.95-13.218-13.29-13.218-7.341 0-13.292 5.918-13.292 13.218 0 7.301 5.95 13.219 13.291 13.219z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.114 112.624l5.169 2.644-1.034-5.728 4.283-4.112-5.907-.881-2.51-5.288-2.66 5.288-5.906.881 4.282 4.112-1.033 5.728 5.316-2.644z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.332 40v20",
    stroke: "#A167FF",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.334 64a2.667 2.667 0 1 0-.001-5.333 2.667 2.667 0 0 0 .001 5.333z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.332 61.333L136 78.667h10.663l-5.331-17.334z",
    fill: "#7B3DED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127 76H72l4.583-30h44.524L127 76z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 46l50 30-5.937-30H77z",
    fill: "#8E57F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 24L52 38.438 76.93 46H100V24zM100 24l47 14.438L122.589 46H100V24z",
    fill: "#441E80"
  }));
};
masterDegree.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var workshop = function workshop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#A167FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.337 40H178.04v96.457H21.337V40z",
    fill: "#fff",
    fillOpacity: ".4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M175.04 43H24.337v90.457H175.04V43zM21.337 40v96.457H178.04V40H21.337z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.597 79.529l.007-3.176 7.065-.007-.006 3.176-7.066.007zm.013-6.352L96.616 70l7.066-.007-.006 3.177-7.066.007zM119.82 89.31l4.3-1.836 2.078 5.276-4.3 1.836-2.078-5.277zm8.599-3.67l4.3-1.836 2.078 5.276-4.299 1.835-2.079-5.276zM79.476 89.442L75.2 87.553l-2.156 5.242 4.277 1.888 2.156-5.242zm-8.554-3.775l-4.276-1.887-2.157 5.242 4.277 1.887 2.156-5.242z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.688 101.805c0 11.045-8.954 20-20 20-11.045 0-20-8.955-20-20 0-11.046 8.955-20 20-20 11.046 0 20 8.954 20 20z",
    fill: "#E7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.688 119.805c9.941 0 18-8.059 18-18 0-9.942-8.059-18-18-18-9.94 0-18 8.058-18 18 0 9.941 8.06 18 18 18zm0 2c11.046 0 20-8.955 20-20 0-11.046-8.954-20-20-20-11.045 0-20 8.954-20 20 0 11.045 8.955 20 20 20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.188 101.805c0 6.664-5.185 12-11.5 12-6.314 0-11.5-5.336-11.5-12 0-6.665 5.186-12 11.5-12 6.315 0 11.5 5.335 11.5 12z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.14 54.636h-14a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zm-14-3a4 4 0 0 0-4 4v8a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4h-14zM155.517 75.303h-14a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1zm-14-3a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h14a4 4 0 0 0 4-4v-10a4 4 0 0 0-4-4h-14zM43.86 75.303h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1zm14-3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4h-14a4 4 0 0 1-4-4v-10a4 4 0 0 1 4-4h14z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#7B3DED"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.299 136.984c-6.265-5.121-14.167-4.765-14.167-4.765s-7.902-.356-14.167 4.765c-6.753 5.512-8.389 15.079-8.389 15.079h45.112c-.034 0-1.67-9.567-8.389-15.079zM127.92 112.958c0-7.156 5.802-12.958 12.959-12.958s12.958 5.802 12.958 12.958v2.688c0 7.157-5.801 12.958-12.958 12.958s-12.959-5.802-12.959-12.958v-2.688zM72.412 137.156c-6.265-5.121-14.167-4.766-14.167-4.766s-7.902-.355-14.167 4.766c-6.754 5.512-8.39 15.079-8.39 15.079h45.113c-.035 0-1.67-9.567-8.389-15.079zM45.033 113.13c0-7.156 5.802-12.958 12.959-12.958 7.156 0 12.958 5.802 12.958 12.958v2.688c0 7.156-5.802 12.958-12.958 12.958-7.157 0-12.959-5.802-12.959-12.958v-2.688z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.853 142.431c-6.95-5.68-15.714-5.286-15.714-5.286s-8.764-.394-15.713 5.286c-7.49 6.114-9.305 16.724-9.305 16.724h50.036c-.039 0-1.853-10.61-9.304-16.724zM85.486 116.177c0-7.938 6.435-14.372 14.372-14.372 7.938 0 14.373 6.434 14.373 14.372v2.981c0 7.937-6.435 14.372-14.373 14.372-7.937 0-14.372-6.435-14.372-14.372v-2.981z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(36 100)",
    d: "M0 0h128v52H0z"
  }))));
};
workshop.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var boardMember = function boardMember(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.529 17l47.529 14.708 47.408-14.707 11.006 48.74 36.523 33.913-36.523 33.912-11.006 48.742-47.408-14.708-47.529 14.708-11.005-48.742L5 99.654l36.524-33.912L52.529 17z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.977 0l35.272 38.441 50.594 11.555-15.322 49.995 15.322 49.995-50.594 11.555-35.272 38.44-35.273-38.44L14 149.986l15.432-49.995L14 49.996 64.704 38.44 99.977.001z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.5",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.046 99.5c0 29.009 23.44 52.452 52.454 52.452 28.921 0 52.454-23.446 52.454-52.451 0-29.009-23.44-52.453-52.454-52.453S47.046 70.492 47.046 99.501zM44 99.5c0 30.694 24.806 55.5 55.5 55.5 30.597 0 55.5-24.806 55.5-55.5C155 68.808 130.194 44 99.5 44S44 68.808 44 99.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.773 133.764V66.115l-58.474-34.03-58.268 34.03v67.649l58.268 33.824 58.474-33.824z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.309 39.5l52.252 30.823v61.3l-52.252 30.636-52.066-30.635V70.322L101.309 39.5z",
    fill: "#5320A3",
    stroke: "#fff",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.917 105.578c-7.954 0-14.168 3.609-14.293 12.632h28.709c-.124-9.023-6.463-12.632-14.416-12.632zM71.696 82.612c-5.388 0-9.902 4.514-9.902 9.902 0 5.388 4.514 9.902 9.902 9.902 5.388 0 9.902-4.514 9.902-9.902 0-5.534-4.368-9.902-9.902-9.902zM130.288 105.578c-7.954 0-14.168 3.609-14.292 12.632h28.708c-.124-9.023-6.463-12.632-14.416-12.632zM131.109 82.612c-5.388 0-9.902 4.514-9.902 9.902 0 5.388 4.514 9.902 9.902 9.902 5.388 0 9.902-4.514 9.902-9.902 0-5.534-4.368-9.902-9.902-9.902z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.33 103.589c-9.24 0-16.46 4.193-16.605 14.676h33.355c-.145-10.483-7.509-14.676-16.75-14.676zM101.074 76.905c-6.26 0-11.505 5.245-11.505 11.505 0 6.26 5.245 11.505 11.505 11.505 6.26 0 11.505-5.245 11.505-11.505 0-6.43-5.076-11.505-11.505-11.505z",
    fill: "#00D8F5"
  }));
};
boardMember.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var casualWork = function casualWork(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.294 63.04c.94 0 1.88.639 2.256 1.49l5.654 17.4c2.253 4.895 6.575 7.876 11.276 7.88l33.466.025c20.493.015 37.027 18.75 37.013 41.939l-.003 5.744-141.95-.106.029-47.868.01-26.505h52.25z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.01 129.649l-.005 7.871 141.95.108.003-5.744.001-2.128-141.95-.107zM113.816 90.049h7.915v18.831h-7.915zM99.449 88.883l7.866.987-1.833 18.716-7.867-.987zM91.778 80.633l5.263 6.692-12.428 12.52-5.262-6.692zM128.076 90.049h7.915v18.831h-7.915zM113.607 56.66l5.688 5.405.69-7.761 6.77-3.822-7.05-3.09-1.594-7.542-5.001 5.867-7.714-.959 3.952 6.696-3.283 7.066 7.542-1.86zM141.168 73.568l4.298 4.084.521-5.864 5.115-2.888-5.326-2.335-1.205-5.698-3.778 4.433-5.829-.724 2.987 5.058-2.481 5.339 5.698-1.405z",
    fill: "#fff"
  }));
};
casualWork.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var contract = function contract(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.37 10.443c35.797-4.59 71.463-4.59 107.26 0 18.751 2.36 33.437 17.177 35.928 35.928 4.589 35.797 4.589 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.437-17.177-35.928-35.928-4.59-35.797-4.59-71.462 0-107.26 2.491-18.75 17.177-33.567 35.928-35.927z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.478 170V30H48v140h104.478z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.582 159.038H68.118c0-5.901-4.848-10.776-10.715-10.776v-96.99c5.867 0 10.715-4.875 10.715-10.776h63.464c0 5.901 4.847 10.776 10.715 10.776v96.99c-5.996 0-10.715 4.747-10.715 10.776z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.157 83.806H78.298v-4h42.859v4z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.64 95.879H70.985v-3h57.655v3zM128.385 106.655h-57.4v-3h57.4v3zM128.64 117.432H70.985v-3h57.655v3zM91.011 128.712H70.985v-3H91.01v3z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.209 58.97l-1.531-2.438.383-2.822-2.169-1.796-.637-2.823-2.807-.641-1.658-2.31-2.806.386-2.424-1.54-2.423 1.668-2.806-.385-1.659 2.31-2.806.64-.638 2.823-2.423 1.668.382 2.822-1.53 2.438 1.53 2.438-.382 2.822 2.296 1.668.638 2.822 1.53.385 1.276.257 1.658 2.309 2.806-.385 2.424 1.54 2.423-1.54 2.934.385 1.658-2.31 1.276-.256 1.531-.385.637-2.822 2.296-1.668-.382-2.823 1.403-2.437zm-10.077 1.411l.893 5.132-4.465-2.438-4.464 2.438.893-5.132-3.7-3.592 5.103-.77 2.296-4.618 2.296 4.618 5.102.77-3.954 3.592z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.132 60.381l.893 5.004-4.465-2.31-4.592 2.31.893-5.004-3.699-3.592 5.102-.77 2.296-4.618 2.169 4.618 5.102.77-3.699 3.592z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.462 137.356c-2.548-1.225-5.184.142-6.293 2.707l-.005.011c-1.054 2.355-1.188 4.987-1.188 7.674h-2c0-2.699.12-5.709 1.36-8.485 1.443-3.33 5.178-5.552 9.003-3.705l.008.004.007.003c1.858.935 2.874 2.767 3.635 4.297l.008.017.008.017c.323.715.625 1.334 1.006 1.794.355.429.729.66 1.216.699.652.043 1.028-.161 1.317-.471.34-.364.605-.927.85-1.669l.013-.039.017-.038c.506-1.188 1.419-1.955 2.691-2.137l.284 1.979c-.504.073-.862.324-1.12.908-.264.787-.636 1.679-1.273 2.361-.698.748-1.66 1.186-2.918 1.101h-.01v-.001c-1.17-.09-2.006-.692-2.607-1.417-.57-.689-.968-1.537-1.281-2.23-.766-1.538-1.533-2.776-2.728-3.38z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.24 143.559v.469h-2v-.495c-.006-2.018-.014-4.986.655-7.522.366-1.386.956-2.739 1.941-3.756 1.013-1.047 2.384-1.671 4.144-1.671 1.89 0 3.285.961 4.265 2.265.959 1.274 1.562 2.918 1.951 4.474.779 3.118.779 6.23.779 6.32v2.309h-2v-2.309c0-.045-.001-2.96-.719-5.835-.361-1.443-.882-2.791-1.609-3.757-.706-.938-1.559-1.467-2.667-1.467-1.237 0-2.083.417-2.707 1.062-.654.675-1.124 1.663-1.444 2.875-.598 2.268-.593 4.979-.589 7.038z",
    fill: "#5320A3"
  }));
};
contract.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var entrepreneur = function entrepreneur(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.709 150V50L99.854 0 13 50v100l86.855 50 86.854-50z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.842 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S33.842 63.413 33.842 100zM30 100c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.933 135.634h-.42c-4.633.084-9.013 2.022-12.298 5.306l-11.791 11.708v-26.447l19.203-19.203 5.306 28.636zM146.577 126.201v26.447l-11.708-11.708c-3.284-3.284-7.664-5.137-12.297-5.306h-.421l5.222-28.047.085-.505 19.119 19.119z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.951 55.115H80.965A172.975 172.975 0 0 1 100 14.855c7.917 12.466 14.403 25.942 18.951 40.26z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.289 108.261c0 9.349-.758 18.445-2.19 27.373H74.817a172.33 172.33 0 0 1-2.19-27.373v-1.263c0-5.054.253-10.023.758-14.908 1.18-12.802 3.79-25.183 7.58-36.975h37.986c3.79 11.792 6.401 24.173 7.58 36.975.505 5.053.758 10.275.758 15.497v.674z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 68.507c-9.265 0-16.76 7.496-16.76 16.76 0 9.265 7.495 16.761 16.76 16.761s16.761-7.496 16.761-16.76c0-9.265-7.496-16.761-16.761-16.761zm0 26.868c-.674 0-1.263-.085-1.853-.169-1.348-.252-2.61-.758-3.706-1.516a5.407 5.407 0 0 1-1.095-.842c-.674-.59-1.263-1.263-1.684-2.022-1.011-1.6-1.6-3.453-1.6-5.474a9.993 9.993 0 0 1 10.022-10.023c2.022 0 3.959.59 5.559 1.685a10.142 10.142 0 0 1 2.021 1.768c.337.422.674.843.927 1.264a8.666 8.666 0 0 1 1.432 3.79c.084.505.168 1.095.168 1.6-.168 5.39-4.632 9.939-10.191 9.939z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.023 85.268c0 5.559-4.548 10.022-10.023 10.022-.674 0-1.263-.084-1.853-.168-1.348-.253-2.61-.758-3.706-1.516a5.408 5.408 0 0 1-1.095-.842c-.674-.59-1.263-1.264-1.684-2.022-1.01-1.6-1.6-3.453-1.6-5.474a9.993 9.993 0 0 1 10.022-10.023c2.022 0 3.959.59 5.559 1.684a10.176 10.176 0 0 1 2.022 1.77c.336.42.673.841.926 1.263a8.666 8.666 0 0 1 1.432 3.79v1.516z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.13 135.634l-13.476 13.392H93.768l-13.392-13.392h39.754z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 68.507V55.115M100 102.028v33.606M105.896 108.766a1.263 1.263 0 1 0 .001-2.527 1.263 1.263 0 0 0-.001 2.527zM105.896 118.031a1.263 1.263 0 1 0 .001-2.527 1.263 1.263 0 0 0-.001 2.527zM105.896 127.527a1.264 1.264 0 1 0 0-2.528 1.264 1.264 0 0 0 0 2.528z",
    stroke: "#66E8F9",
    strokeWidth: "1.62",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.032 183l-7.79-9.412c-6.915-8.353-2.046-22.588 7.79-22.588 9.738 0 14.607 14.235 7.79 22.588l-7.79 9.412z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 172l-4.228-4.692C91.978 163.098 94.688 156 100 156c5.312 0 8.022 7.098 4.228 11.308L100 172z",
    fill: "#fff"
  }));
};
entrepreneur.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var founder = function founder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.529 17l47.529 14.708 47.408-14.707 11.006 48.74 36.523 33.913-36.523 33.912-11.006 48.742-47.408-14.708-47.529 14.708-11.005-48.742L5 99.654l36.524-33.912L52.529 17z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.977 0l35.272 38.441 50.594 11.555-15.322 49.995 15.322 49.995-50.594 11.555-35.272 38.44-35.273-38.44L14 149.986l15.432-49.995L14 49.996 64.704 38.44 99.977.001z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.5",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.046 99.5c0 29.009 23.44 52.452 52.454 52.452 28.921 0 52.454-23.446 52.454-52.451 0-29.009-23.44-52.453-52.454-52.453S47.046 70.492 47.046 99.501zM44 99.5c0 30.694 24.806 55.5 55.5 55.5 30.597 0 55.5-24.806 55.5-55.5C155 68.808 130.194 44 99.5 44S44 68.808 44 99.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.361 132.5v-65L99.906 35 43.45 67.5v65L99.906 165l56.455-32.5z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 48L47.3 71.767h105.4L100 48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 73.833H38v13.434h124V73.833z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 71.764H38v5.166h124v-5.166z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.78 87.411H70.643v52.549H83.78V87.411zM106.769 87.411H93.632v52.549h13.137V87.411zM129.759 87.411h-13.137v52.549h13.137V87.411zM152.749 87.411h-13.137v52.549h13.137V87.411zM60.79 87.411H47.653v52.549H60.79V87.411z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.9 136.864H41.1v5.166h117.8v-5.166z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.967 142.03H38v5.167h122.967v-5.167z",
    fill: "#fff"
  }));
};
founder.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var fullTime = function fullTime(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M187.541 150.167v-100l-86.855-50-86.854 50v100l86.854 50 86.855-50z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.832 170.167c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.674 100.167c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S34.674 63.58 34.674 100.167zm-3.842 0c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "100",
    cy: "100",
    r: "62",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.127 84.873C61.127 78.868 65.995 74 72 74c6.005 0 10.873 4.868 10.873 10.873v2.254C82.873 93.132 78.005 98 72 98c-6.005 0-10.873-4.868-10.873-10.873v-2.254zM84.243 105.292c-5.501-4.521-12.439-4.207-12.439-4.207s-6.937-.314-12.439 4.207C53.436 110.157 52 118.601 52 118.601H91.609c-.03 0-1.467-8.444-7.366-13.309zM140.243 105.292c-5.501-4.521-12.439-4.207-12.439-4.207s-6.937-.314-12.438 4.207c-5.93 4.865-7.366 13.309-7.366 13.309H147.609c-.031 0-1.467-8.444-7.366-13.309z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.702 113.288c-6.944-5.676-15.702-5.282-15.702-5.282s-8.758-.394-15.702 5.282C76.813 119.397 75 130 75 130h50c-.039 0-1.852-10.603-9.298-16.712z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.233 110.19l.006.005c4.443 3.645 7.078 8.503 8.595 12.233a40.99 40.99 0 0 1 1.608 4.785c.163.608.279 1.1.355 1.443l.074.333a.635.635 0 0 0 .009.04l.007.036-.003-.016-.005-.021-.007-.028a5.66 5.66 0 0 0-.033-.121l-.001-.003a4.165 4.165 0 0 0-.13-.376c-.03-.073-.137-.338-.333-.646-.114-.17.567 3.694.333 3.463-.439-.346 1.087 2.787.179 2.683L125 130c-.003 0-.015-.057-.039-.166a34.452 34.452 0 0 0-1.064-3.834c-1.232-3.643-3.677-9.005-8.195-12.712-6.944-5.676-15.702-5.282-15.702-5.282s-8.758-.394-15.702 5.282c-4.542 3.707-6.995 9.069-8.222 12.712-.796 2.361-1.076 4-1.076 4-3.943-.674-3.942-.677-3.942-.677l.001-.008.003-.015.007-.042a15.19 15.19 0 0 1 .111-.558c.076-.358.19-.859.352-1.471.322-1.22.833-2.905 1.605-4.801 1.52-3.736 4.166-8.594 8.63-12.238M75 130l-3.943-.674-.8 4.674H125v-4H75zm3.94.685l.002-.004-.001.004zm2.828-20.496c4.137-3.381 8.74-4.902 12.201-5.593a31.04 31.04 0 0 1 4.332-.557 23.963 23.963 0 0 1 1.69-.035h.018a23.956 23.956 0 0 1 1.69.035c1.083.06 2.586.208 4.332.557 3.461.692 8.065 2.213 12.202 5.594",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.357 86.66c0-7.933 6.43-14.363 14.362-14.363s14.363 6.43 14.363 14.362v2.979c0 7.932-6.431 14.362-14.363 14.362-7.932 0-14.362-6.43-14.362-14.362v-2.979z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.127 84.873C117.127 78.868 121.995 74 128 74c6.005 0 10.873 4.868 10.873 10.873v2.254C138.873 93.132 134.005 98 128 98c-6.005 0-10.873-4.868-10.873-10.873v-2.254z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 100c0-33.137-26.863-60-60-60v-4c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64v-4c33.137 0 60-26.863 60-60zM40 100c0 33.137 26.863 60 60 60v4c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64v4c-33.137 0-60 26.863-60 60z",
    fill: "#4D38E1"
  }));
};
fullTime.defaultProps = {
  width: "201",
  height: "201",
  viewBox: "0 0 201 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var internship = function internship(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 132.324c0-30.553 25.044-55.272 56-55.272s56 24.719 56 55.272H44z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.726 55.178c-.54-.178-1.08-.178-1.62-.178C58.601 55 55 58.556 55 63s3.602 8 8.105 8c.54 0 .9 0 1.261-.178h.36L103.632 63l-38.906-7.822z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.905 70.822c.36.178.901.178 1.441.178 4.503 0 8.105-3.556 8.105-8s-3.602-8-8.105-8c-.54 0-.9 0-1.261.178h-.18-.18L97 63l38.905 7.822c-.18 0-.18 0 0 0z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98 77.052v-14h4v14h-4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 71.052a8 8 0 1 0 0-16 8 8 0 0 0 0 16z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 66.052a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM100 77.052c-30.956 0-56 24.719-56 55.272h38.422v-9.365c0-17.503 6.69-33.625 17.578-45.907z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.578 132.324H156c0-30.553-25.044-55.272-56-55.272 10.889 12.282 17.578 28.25 17.578 45.907v9.365z",
    fill: "#00CEEA"
  }));
};
internship.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var partTime = function partTime(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M187.541 150.167v-100l-86.855-50-86.854 50v100l86.854 50 86.855-50z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.832 170.167c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.674 100.167c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S34.674 63.58 34.674 100.167zm-3.842 0c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "100",
    cy: "100",
    r: "62",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.128 84.873C61.128 78.868 65.996 74 72 74c6.004 0 10.872 4.868 10.872 10.873v2.254C82.873 93.132 78.005 98 72.001 98c-6.005 0-10.873-4.868-10.873-10.873v-2.254zM84.244 105.292c-5.501-4.521-12.44-4.207-12.44-4.207s-6.937-.314-12.438 4.207c-5.93 4.865-7.365 13.309-7.365 13.309h39.608c-.03 0-1.467-8.444-7.365-13.309zM140.244 105.292c-5.502-4.521-12.439-4.207-12.439-4.207s-6.938-.314-12.439 4.207c-5.929 4.865-7.366 13.309-7.366 13.309H147.609c-.03 0-1.467-8.444-7.365-13.309z",
    fill: "#00CEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.703 113.288c-6.945-5.676-15.703-5.282-15.703-5.282s-8.757-.394-15.702 5.282C76.814 119.397 75.001 130 75.001 130H125c-.038 0-1.851-10.603-9.297-16.712z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.234 110.19l.006.005c4.442 3.645 7.077 8.503 8.594 12.233a40.614 40.614 0 0 1 1.608 4.785c.163.608.279 1.1.356 1.443l.073.333a1.474 1.474 0 0 1 .017.076l-.004-.016-.005-.021-.007-.028c-.005-.02-.016-.064-.033-.121l-.001-.003a3.915 3.915 0 0 0-.462-1.022c-.115-.17.566 3.694.332 3.463-.439-.346 1.087 2.787.18 2.683L125 130c-.002 0-.015-.057-.038-.166-.103-.473-.416-1.915-1.065-3.834-1.232-3.643-3.676-9.005-8.194-12.712-6.945-5.676-15.703-5.282-15.703-5.282s-8.757-.394-15.702 5.282c-4.541 3.707-6.995 9.069-8.222 12.712-.795 2.361-1.076 4-1.076 4-3.942-.674-3.942-.677-3.942-.677l.002-.008.002-.015.008-.042a15.19 15.19 0 0 1 .11-.558c.077-.358.191-.859.353-1.471.321-1.22.833-2.905 1.605-4.801 1.519-3.736 4.166-8.594 8.629-12.238M75 130l-3.942-.674-.8 4.674H125v-4H75zm3.941.685l.001-.004v.004zm2.828-20.496c4.137-3.381 8.74-4.902 12.2-5.593a31.04 31.04 0 0 1 4.332-.557 23.96 23.96 0 0 1 1.69-.035h.018a23.961 23.961 0 0 1 1.691.035c1.083.06 2.586.208 4.331.557 3.462.692 8.066 2.213 12.203 5.594",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.357 86.66c0-7.933 6.43-14.363 14.363-14.363 7.932 0 14.362 6.43 14.362 14.362v2.979c0 7.932-6.43 14.362-14.362 14.362s-14.363-6.43-14.363-14.362v-2.979z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.128 84.873c0-6.005 4.868-10.873 10.873-10.873 6.004 0 10.872 4.868 10.872 10.873v2.254c0 6.005-4.868 10.873-10.872 10.873-6.005 0-10.873-4.868-10.873-10.873v-2.254z",
    fill: "#00CEEA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 100c0-33.137-26.863-60-60-60v-4c35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64v-4c33.137 0 60-26.863 60-60z",
    fill: "#4D38E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 100c0 33.137 26.863 60 60 60v4c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64v4c-33.137 0-60 26.863-60 60z",
    fill: "#fff"
  }));
};
partTime.defaultProps = {
  width: "201",
  height: "201",
  viewBox: "0 0 201 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sideHustle = function sideHustle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.307 164.451l56.133-97.925-48.962-28.067-56.134 97.926 48.963 28.066z",
    fill: "#00B3DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.842 151.307l-26.787-15.355c1.644-2.869.503-6.545-2.58-8.312l42.356-73.89c3.082 1.768 6.831.894 8.476-1.974l26.787 15.354c-1.645 2.87-.504 6.546 2.579 8.313l-42.356 73.889c-3.082-1.767-6.831-.894-8.475 1.975z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.577 94.396c-3.883 6.774-1.54 15.413 5.234 19.296 6.774 3.883 15.413 1.54 19.296-5.234 3.883-6.774 1.54-15.413-5.234-19.296-6.774-3.884-15.413-1.54-19.296 5.234z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.743 96.212c-2.881 5.026-1.142 11.435 3.884 14.316 5.026 2.881 11.436 1.143 14.317-3.883 2.881-5.026 1.142-11.436-3.884-14.317-5.026-2.88-11.436-1.142-14.317 3.884z",
    fill: "#00CEEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.389 156.039l30.462-108.685-54.343-15.231-30.462 108.685 54.343 15.231z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.459 147.69l-29.707-8.326c.456-3.343-1.517-6.539-4.733-7.871l24.158-86.192c3.44.533 6.786-1.172 8.135-4.265l29.706 8.326c-.455 3.343 1.517 6.539 4.733 7.872l-24.158 86.191c-3.439-.532-6.786 1.173-8.134 4.265z",
    fill: "#fff",
    stroke: "#00D8F5",
    strokeWidth: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.815 90.613c-2.107 7.518 2.28 15.321 9.798 17.429 7.518 2.107 15.321-2.28 17.428-9.798 2.108-7.518-2.279-15.321-9.797-17.428-7.518-2.108-15.321 2.279-17.429 9.797z",
    fill: "#BFF5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.329 91.6c-1.564 5.577 1.691 11.366 7.269 12.93 5.578 1.563 11.367-1.691 12.931-7.27 1.563-5.577-1.692-11.367-7.27-12.93-5.578-1.564-11.367 1.691-12.93 7.27z",
    fill: "#00D8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.384 75.423c-3.337-12.457-15.938-19.762-28.352-16.436-12.413 3.326-19.674 15.953-16.336 28.41-3.338-12.457-15.939-19.762-28.352-16.436-12.413 3.326-19.674 15.953-16.336 28.41 1.602 5.98 5.687 11.294 10.728 14.216l49.143 28.488 28.316-49.243c1.911-4.785 2.925-10.931 1.189-17.41z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.172 110.366a1.897 1.897 0 1 0-1.867 3.303c12.13 6.856 27.49 2.76 34.404-9.232a1.897 1.897 0 1 0-3.287-1.895c-5.857 10.157-18.903 13.672-29.25 7.824z",
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }));
};
sideHustle.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var exercise = function exercise(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.822 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.424 0 93 41.699 93 93 .122 51.424-41.576 93-93 93z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.822 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75 41.479 0 75 33.522 75 75 0 41.479-33.521 75-75 75z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.322 94h-165v14h165V94z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.822 94h29l-8.377 14H64.822V94z",
    fill: "#D0F6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.179 63h-20v74.581h20V63zM168.179 69h-12v62.151h12V69z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.179 137.581V63h2v74.581h-2z",
    fill: "#D0F6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.178 69h-12v62.151h12V69zM65.178 63h-20v74.581h20V63z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.443 63v75h-2V63h2z",
    fill: "#D0F6E9"
  }));
};
exercise.defaultProps = {
  width: "202",
  height: "201",
  viewBox: "0 0 202 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var home = function home(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.57 81.163L99.9 38.881l42.33 42.282M142.23 81.163H57.57v66.008h84.66V81.163z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.901 30.171l54.683 54.62-6.361 6.368-48.322-48.267L51.58 91.16l-6.36-6.368L99.9 30.171z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.742 96.7a12.244 12.244 0 0 0-12.302-12.288A12.244 12.244 0 0 0 100.138 96.7a12.244 12.244 0 0 0-12.302-12.288A12.244 12.244 0 0 0 75.534 96.7c0 3.277 1.367 6.554 3.554 8.738l21.323 21.299 21.323-21.299c1.641-2.184 3.008-5.188 3.008-8.738z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.568 122.777c-.175 0-.385.035-.56.035-3.674.422-6.963 2.675-8.853 5.878l-5.354 8.976 8.923-5.385c3.184-1.936 5.424-5.21 5.809-8.941 0-.176.035-.352.035-.563z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 122.777c.175 0 .385.035.56.035 3.709.387 6.963 2.64 8.888 5.843l5.353 9.011-8.957-5.385c-3.185-1.936-5.389-5.21-5.809-8.941 0-.176-.035-.352-.035-.563zM165.568 132.281c-.175 0-.385.035-.56.035-3.674.422-6.963 2.675-8.853 5.878l-5.354 8.976 8.923-5.385c3.184-1.936 5.424-5.21 5.809-8.941 0-.176.035-.352.035-.563z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136 132.281c.175 0 .385.035.56.035 3.709.387 6.963 2.64 8.888 5.843l5.353 9.011-8.922-5.385c-3.185-1.936-5.424-5.21-5.809-8.941a2.75 2.75 0 0 1-.07-.563z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M150.494 147.17v-25.344h.663v25.344h-.663z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.399 112.322c0-1.9-1.225-3.484-2.94-4.012.805-1.584.56-3.591-.769-4.928a4.203 4.203 0 0 0-4.899-.775 4.183 4.183 0 0 0-3.989-2.957 4.18 4.18 0 0 0-3.989 2.957 4.202 4.202 0 0 0-4.899.775c-1.33 1.337-1.575 3.344-.77 4.928a4.168 4.168 0 0 0-2.939 4.012 4.168 4.168 0 0 0 2.939 4.013c-.805 1.584-.56 3.591.77 4.928a4.202 4.202 0 0 0 4.899.775 4.181 4.181 0 0 0 3.989 2.956 4.183 4.183 0 0 0 3.989-2.956 4.203 4.203 0 0 0 4.899-.775c1.329-1.337 1.574-3.344.769-4.928a4.213 4.213 0 0 0 2.94-4.013z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.802 116.546c-2.31 0-4.199-1.9-4.199-4.224 0-2.323 1.889-4.224 4.199-4.224 2.309 0 4.199 1.901 4.199 4.224 0 2.324-1.89 4.224-4.199 4.224z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.955 126.835c11.045 0 20-9.022 20-20.152 0-11.129-8.955-20.151-20-20.151-11.046 0-20 9.022-20 20.151 0 11.13 8.954 20.152 20 20.152z",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47 147.532v-48h2v48h-2z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.115 110.685l-7.637 8.657-.951-.852 7.637-8.658.951.853zM43.706 105.666l4.774 5.451-.955.848-4.773-5.45.954-.849z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(136 99.65)",
    d: "M0 0h29.568v47.52H0z"
  }))));
};
home.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var hobby = function hobby(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100 193c-51.302 0-93-41.576-93-93C7 48.577 48.698 7 100 7c51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.862 134.531a8.14 8.14 0 0 0 .219-2.73c-.351-4.241-3.818-7.727-8.208-8.231-.307 0-.614-.042-.877-.042-2.107-.042-4.126-.84-5.531-2.352-1.536-1.637-3.775-2.645-6.233-2.645a8.557 8.557 0 0 0-6.188 2.603c-1.624 1.722-3.995 2.688-6.409 2.436-.351-.042-.658-.042-1.009-.042-2.897 0-5.487 1.26-7.199 3.192-1.712 1.931-2.812 6.311-2.312 7.811h43.747zM52 79.704c4 0 7.42 2.805 8.82 6.796.42 1.186 1.44 1.87 2.56 1.87h.02c3.1 0 5.88 1.71 7.6 4.334H25c1.96-3.878 5.66-6.5 9.88-6.5 1.74 0 3.4.456 4.88 1.254.38.205.78.296 1.16.296 1.02 0 2-.661 2.44-1.779 1.52-3.694 4.82-6.271 8.64-6.271z",
    fill: "#D0F6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3 74.195l-.199.098-38.476-10.226 9.131-33.799L151.3 74.195z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.755 30.268l-9.131 33.8-38.476-10.226-.123-.183 47.73-23.39z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.625 64.067l-18.148 67.178-20.328-77.403 38.476 10.225z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.101 74.293l-56.625 56.952 18.149-67.178 38.476 10.226z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.949 30.888L88.311 160.227c-2.61 9.739-12.51 15.442-22.259 12.83l.777-2.898c8.153 2.185 16.405-2.574 18.585-10.708l34.637-129.34 2.898.777z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.201 144.08a6.451 6.451 0 0 1 2.38-8.879 6.452 6.452 0 0 1 8.879 2.379l3.25 5.629-5.63 3.25a6.452 6.452 0 0 1-8.879-2.379zm3.88-6.281c-1.708.986-2.267 3.074-1.282 4.781.986 1.707 3.074 2.267 4.781 1.281l3.031-1.75-1.75-3.031c-.985-1.707-3.073-2.267-4.78-1.281z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.459 141.58a6.45 6.45 0 0 1-2.379 8.879 6.451 6.451 0 0 1-8.879-2.379l-3.25-5.629 5.63-3.25a6.451 6.451 0 0 1 8.878 2.379zm-3.879 6.281c1.708-.986 2.267-3.074 1.281-4.781-.985-1.707-3.073-2.267-4.78-1.281l-3.032 1.75 1.75 3.031c.986 1.707 3.074 2.267 4.781 1.281z",
    fill: "#5320A3"
  }));
};
hobby.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var mentoring = function mentoring(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M196.044 157.5v-105L104.847 0 13.65 52.5v105l91.197 52.5 91.197-52.5z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M105 178.5c-40.649 0-73.5-32.851-73.5-73.5S64.351 31.5 105 31.5s73.5 32.851 73.5 73.5-32.851 73.5-73.5 73.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.534 105c0 38.417 31.042 69.463 69.466 69.463 38.3 0 69.466-31.051 69.466-69.463 0-38.417-31.042-69.463-69.466-69.463-38.424 0-69.466 31.046-69.466 69.463zm-4.034 0c0 40.649 32.851 73.5 73.5 73.5 40.521 0 73.5-32.851 73.5-73.5S145.649 31.5 105 31.5 31.5 64.351 31.5 105z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    r: "32.779",
    transform: "matrix(-1 0 0 1 58.779 76.779)",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#01BA99",
    d: "M91.557 79.758H26v47.678h65.557zM73.678 127.436H26v29.799h47.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.476 103.597l-11.92-23.839v23.839h11.92z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "151.698",
    cy: "76.778",
    r: "32.779",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD09F",
    d: "M118.92 79.758h65.557v47.678H118.92zM136.799 127.436h47.678v29.799h-47.678z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107 103.597l11.92-23.839v23.839H107z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("circle", {
    r: "24",
    transform: "matrix(-1 0 0 1 59 77)",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.37 89.764a2 2 0 0 0 2.827.057L74.353 77.19 61.197 64.557a2 2 0 1 0-2.77 2.886l8.068 7.746H46a2 2 0 0 0 0 4h20.495l-8.069 7.747a2 2 0 0 0-.057 2.828zM152 97c-11.046 0-20-8.954-20-20s8.954-20 20-20 20 8.954 20 20-8.954 20-20 20zm0 4c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.691 67.835a2.5 2.5 0 0 1 .915 3.415l-10.031 17.374-10.825-6.25a2.5 2.5 0 0 1 2.5-4.33l6.495 3.75 7.531-13.044a2.5 2.5 0 0 1 3.415-.915z",
    fill: "#fff"
  }));
};
mentoring.defaultProps = {
  width: "210",
  height: "210",
  viewBox: "0 0 210 210",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var travel = function travel(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.37 10.443c35.797-4.59 71.463-4.59 107.26 0 18.751 2.36 33.437 17.177 35.928 35.928 4.589 35.797 4.589 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.437-17.177-35.928-35.928-4.59-35.797-4.59-71.462 0-107.26 2.491-18.75 17.177-33.567 35.928-35.927z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.868 57c.22-.882.307-1.806.22-2.73-.352-4.241-3.819-7.727-8.208-8.23-.308 0-.615-.043-.878-.043-2.107-.042-4.126-.84-5.531-2.351-1.536-1.638-3.774-2.646-6.232-2.646s-4.653 1.008-6.189 2.604c-1.624 1.721-3.994 2.687-6.408 2.435-.351-.042-.659-.042-1.01-.042-2.897 0-5.486 1.26-7.198 3.192-1.712 1.932-2.813 6.311-2.313 7.811h43.747z",
    fill: "#D0F6E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.234 116.173l-18.758 2.426-1.984-14.026 8.995-1.272 5.412 4.814 6.335 8.058z",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.302 113.998c.159 1.123.157 2.124.156 3.126-.186 2.745-1.274 5.188-2.843 7.27-2.172 2.882-5.448 5.062-9.383 5.619L52.5 142.139c-15.6 2.206-29.894-8.649-32.076-24.078l113.84-16.101c6.746-.955 12.882 2.899 15.18 9.012a11 11 0 0 1 .858 3.026z",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.424 162.04l6.794-24.751 30.733-4.31-24.547 28.677-12.98.384zM32.9 108.115l-13.633 1.928-1.215-8.822s5.814-1.56 8.721 0 6.126 6.894 6.126 6.894z",
    fill: "#2BD09F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.891 88.062c.197 1.39.194 2.63.192 3.872-.229 3.4-1.577 6.426-3.52 9.004-2.692 3.571-6.749 6.272-11.623 6.961l-106.195 15.02c-19.323 2.733-37.03-10.712-39.732-29.825L162.025 73.15c8.356-1.182 15.956 3.591 18.803 11.164a13.68 13.68 0 0 1 1.063 3.748z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.89 88.062c.196 1.39.194 2.63.192 3.872l-17.06 2.413c-2.089.295-4.076-1.196-4.371-3.28-.295-2.086 1.2-4.07 3.289-4.365l16.887-2.388a13.68 13.68 0 0 1 1.063 3.748zM86.058 106.047a4.391 4.391 0 0 0 3.738-4.959 4.391 4.391 0 0 0-4.967-3.728 4.391 4.391 0 0 0-3.738 4.959 4.391 4.391 0 0 0 4.967 3.728zM67.604 108.657a4.391 4.391 0 0 0 3.738-4.959 4.391 4.391 0 0 0-4.966-3.728 4.391 4.391 0 0 0-3.738 4.959 4.391 4.391 0 0 0 4.966 3.728zM104.51 103.437a4.391 4.391 0 0 0 3.738-4.96 4.391 4.391 0 0 0-4.967-3.727 4.391 4.391 0 0 0-3.737 4.959 4.39 4.39 0 0 0 4.966 3.728zM122.966 100.827a4.392 4.392 0 0 0 3.738-4.96 4.392 4.392 0 0 0-4.967-3.728 4.391 4.391 0 0 0-3.738 4.96 4.391 4.391 0 0 0 4.967 3.728zM141.419 98.217a4.391 4.391 0 0 0 3.738-4.96 4.39 4.39 0 0 0-4.966-3.728 4.39 4.39 0 0 0-3.738 4.96 4.39 4.39 0 0 0 4.966 3.728zM44.244 90.089L21.01 93.094 18.55 75.719l11.142-1.576 6.703 5.964 7.848 9.982z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.397 80.107l-16.886 2.389-1.505-10.93s7.202-1.932 10.803 0c3.601 1.934 7.588 8.541 7.588 8.541zM84.186 147.571l8.415-30.66 38.069-5.338-30.405 35.522-16.08.476z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.441 142.569s-7.203 8.232-10.29 10.804c-3.087 2.573-11.833 1.544-11.833 1.544l2.737-10.887 19.386-1.461z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 135c4 0 7.42 2.805 8.82 6.796.42 1.186 1.44 1.871 2.56 1.871h.02c3.1 0 5.88 1.71 7.6 4.333H21c1.96-3.877 5.66-6.5 9.88-6.5 1.74 0 3.4.456 4.88 1.254.38.206.78.297 1.16.297 1.02 0 2-.662 2.44-1.779C40.88 137.577 44.18 135 48 135z",
    fill: "#D0F6E9"
  }));
};
travel.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var volunteer = function volunteer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.709 150V50L99.854 0 13 50v100l86.855 50 86.854-50z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.842 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S33.842 63.413 33.842 100zM30 100c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100 165c-35.948 0-65-29.052-65-65s29.052-65 65-65 65 29.052 65 65-29.052 65-65 65z",
    fill: "#44DDA6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.759 76.61v61.521c0 5.799-4.549 10.59-10.362 10.968V187H82.718v-37.901c-5.94-.631-11.12-4.791-13.016-10.464 0 0-.126-.126-.126-.252L51 91.359l1.264-.504c5.813-2.27 12.51.63 14.785 6.43l7.202 18.153V62.615c0-1.89.759-3.656 2.022-4.79 1.264-1.26 2.907-2.017 4.802-2.017a6.788 6.788 0 0 1 6.824 6.807v33.283h1.264v-40.09c0-1.891.758-3.53 2.022-4.79C92.448 49.755 94.09 49 95.987 49a6.787 6.787 0 0 1 6.823 6.808v40.216h1.264V68.036c0-1.89.758-3.656 2.022-4.79 1.264-1.26 2.906-2.017 4.802-2.017a6.788 6.788 0 0 1 6.824 6.807v27.988h1.263V76.609c0-1.89.759-3.53 2.022-4.79 1.264-1.261 2.907-2.018 4.802-2.018 3.918 0 6.95 3.026 6.95 6.808z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116 113.839c0-4.355-3.556-7.839-8-7.839s-8 3.484-8 7.839c0-4.355-3.556-7.839-8-7.839s-8 3.484-8 7.839c0 2.09.889 4.18 2.311 5.574L100.178 133l13.866-13.587c1.067-1.394 1.956-3.31 1.956-5.574z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 160H78v22h47v-22z",
    fill: "#01BA99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 182H79v6l21 12 24-14v-4z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.882 169.035a2.967 2.967 0 1 0 0-5.935 2.968 2.968 0 0 0 0 5.935z",
    fill: "#D0F6E9"
  }));
};
volunteer.defaultProps = {
  width: "200",
  height: "200",
  viewBox: "0 0 200 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var article = function article(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.997 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.997 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.997 49h-82v110h82V49z",
    fill: "#F05C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.998 37h-95.66v114.792h95.66V37z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.432 49H60.904v19.132h76.528V49zM80.035 106.396V87.264H60.903v19.132h19.132z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.904 77.698h76.528M89.601 87.264h47.83M89.601 96.83h47.83M89.601 106.396h47.83M89.601 115.962h47.83",
    stroke: "#F05C42",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.904 115.962h19.132M60.904 125.528h19.132M60.904 135.094h19.132",
    stroke: "#FFB4A4",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.601 125.528h47.83M89.601 135.094h47.83",
    stroke: "#F05C42",
    strokeWidth: "3",
    strokeMiterlimit: "10"
  }));
};
article.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var book = function book(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.87 10.443c35.797-4.59 71.463-4.59 107.26 0 18.751 2.36 33.437 17.177 35.928 35.928 4.589 35.797 4.589 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.437-17.177-35.928-35.928-4.59-35.797-4.59-71.462 0-107.26 2.491-18.75 17.177-33.567 35.928-35.927z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100.5 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.899 62.447V148L108.4 137.352v3.304H91.815v-3.304L27.5 148V62.447h145.399z",
    fill: "#F05C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.675 59.568V135c-26.88-8.863-53.759-2.64-61.141-.566-.379.189-.757.189-.947.377-.189 0-.568-.188-.946-.377-7.383-2.074-34.262-8.109-61.141.566V59.568c3.218-.942 6.247-1.885 9.465-2.451 3.596-.754 7.382-1.32 10.79-1.697 3.217-.189 6.435-.378 9.464-.378 4.353 0 8.518.19 12.303.566 10.033.943 17.604 3.018 20.065 3.772 5.679-1.697 33.883-9.052 62.088.188z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.159 98.981c10.6-1.697 26.69-3.017 43.537.943M108.159 88.044c10.6-1.697 26.69-3.018 43.537.943M108.159 77.106c10.6-1.697 26.69-3.017 43.537.943M108.159 66.357c10.6-1.886 26.879-3.017 43.537.943M108.159 120.668c10.6-1.698 26.69-3.018 43.537.943M108.159 109.73c10.6-1.697 26.69-3.017 43.537.943M49.48 99.924c16.846-3.96 32.936-2.64 43.536-.943M49.48 88.987c16.846-3.96 32.936-2.64 43.536-.943M49.48 78.049c16.846-3.96 32.936-2.64 43.536-.943M49.48 67.3c16.846-3.96 32.936-2.829 43.536-.943M49.48 121.611c16.846-3.961 32.936-2.641 43.536-.943M49.48 110.673c16.846-3.96 32.936-2.64 43.536-.943",
    stroke: "#FFE0D9",
    strokeWidth: "4",
    strokeMiterlimit: "10",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.218 55.042v37.15l-10.032-4.148-10.033 4.148V57.117c3.597-.755 7.383-1.32 10.79-1.697 3.029-.189 6.246-.378 9.275-.378z",
    fill: "#5320A3"
  }));
};
book.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var podcast = function podcast(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M46.87 10.443c35.797-4.59 71.463-4.59 107.26 0 18.751 2.36 33.437 17.177 35.928 35.928 4.589 35.797 4.589 71.462 0 107.259-2.36 18.751-17.177 33.437-35.928 35.928-35.797 4.59-71.463 4.59-107.26 0-18.75-2.36-33.437-17.177-35.928-35.928-4.59-35.797-4.59-71.462 0-107.26 2.491-18.75 17.177-33.567 35.928-35.927z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".8",
    d: "M100.5 175c-41.478 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.5 164.726v-30.822h12v30.822h-12z",
    fill: "#F05C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 101.582a2.5 2.5 0 0 1 2.5 2.5v9.018c0 10.517 8.394 18.961 18.735 18.961h17.733c10.342 0 18.735-8.444 18.735-18.961v-9.018a2.5 2.5 0 0 1 5 0v9.018c0 13.228-10.582 23.961-23.735 23.961H91.235c-13.153 0-23.735-10.733-23.735-23.961v-9.018a2.5 2.5 0 0 1 2.5-2.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.751 123.466H91.125c-7 0-12.625-5.685-12.625-12.76V56.76C78.5 49.685 84.125 44 91.126 44h19.625c7.001 0 12.626 5.685 12.626 12.76v53.946c0 7.075-5.625 12.76-12.626 12.76z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.251 74.978H78.5v5.685h33.751v-5.685zM112.251 62.344H78.5v5.685h33.751v-5.685zM112.251 101H78.5v5.685h33.751V101zM112.251 88H78.5v5.685h33.751V88z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.239 28C83.856 28 70.5 41.468 70.5 58.078h-4C66.5 39.299 81.607 24 100.239 24h.791c18.632 0 33.74 15.299 33.74 34.078h-4c0-16.61-13.357-30.078-29.74-30.078h-.791z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.076 60.765c-.859 0-1.596-.706-1.596-1.53 0-1.176-.982-2.235-2.333-2.235h-3.314c-1.228 0-2.333.941-2.333 2.235v33.296c0 1.176.982 2.235 2.333 2.235h3.314c1.228 0 2.333-.941 2.333-2.235 0-.824.737-1.53 1.596-1.53 3.438 0 6.261-2.706 6.261-6V66.765c0-3.294-2.823-6-6.261-6zM62.761 60.765c.86 0 1.596-.706 1.596-1.53 0-1.176.983-2.235 2.333-2.235h3.315c1.228 0 2.332.941 2.332 2.235v33.296c0 1.176-.982 2.235-2.332 2.235H66.69c-1.228 0-2.333-.941-2.333-2.235 0-.824-.736-1.53-1.596-1.53-3.437 0-6.261-2.706-6.261-6V66.765c0-3.294 2.824-6 6.261-6zM131.494 175H70.5c0-5.708 4.518-10.274 10.166-10.274h40.662c5.648 0 10.166 4.68 10.166 10.274z",
    fill: "#5320A3"
  }));
};
podcast.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var project = function project(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M187.706 150V50L100.852 0 13.997 50v100l86.855 50 86.854-50z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.997 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.839 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.158-29.573 66.158-66.156 0-36.587-29.564-66.156-66.158-66.156S34.839 63.413 34.839 100zm-3.842 0c0 38.713 31.287 70 70 70 38.591 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.997 39h94v122h-94V39z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.997 48h3v1.8h-1.1V51h-1.9v-3zm0 33v3h3v-1.8h-1.1V81h-1.9zm73 3h3v-3h-1.9v1.2h-1.1V84zm3-33v-3h-3v1.8h1.1V51h1.9zm-70.3-3v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm7.6 0v3h3.8v-3h-3.8zm9.5 5.4h-3V57h3v-3.6zm0 7.2h-3v3.6h3v-3.6zm0 7.2h-3v3.6h3v-3.6zm0 7.2h-3v3.6h3V75zm-5.7 9v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-7.6 0v-3h-3.8v3h3.8zm-9.5-5.4h3V75h-3v3.6zm0-7.2h3v-3.6h-3v3.6zm0-7.2h3v-3.6h-3v3.6zm0-7.2h3v-3.6h-3V57zM106.997 94h3v2.036h-1V97h-2v-3zm0 54v3h3v-2.036h-1V148h-2zm29 3h3v-3h-2v.964h-1V151zm3-54v-3h-3v2.036h1V97h2zm-26-3v3h4v-3h-4zm8 0v3h4v-3h-4zm8 0v3h4v-3h-4zm10 6.107h-3v4.072h3v-4.072zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.142h-3v4.072h3v-4.072zm-6 10.179v-3h-4v3h4zm-8 0v-3h-4v3h4zm-8 0v-3h-4v3h4zm-10-6.107h3v-4.072h-3v4.072zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.142h3v-4.072h-3v4.072zM62.997 94h3v2.036h-.875V97h-2.125v-3zm0 54v3h3v-2.036h-.875V148h-2.125zm31 3h3v-3h-2.125v.964h-.875V151zm3-54v-3h-3v2.036h.875V97h2.125zm-27.625-3v3h4.25v-3h-4.25zm8.5 0v3h4.25v-3h-4.25zm8.5 0v3h4.25v-3h-4.25zm10.625 6.107h-3v4.072h3v-4.072zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.143h-3v4.071h3v-4.071zm0 8.142h-3v4.072h3v-4.072zM90.622 151v-3h-4.25v3h4.25zm-8.5 0v-3h-4.25v3h4.25zm-8.5 0v-3h-4.25v3h4.25zm-10.625-6.107h3v-4.072h-3v4.072zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.143h3v-4.071h-3v4.071zm0-8.142h3v-4.072h-3v4.072z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.913 91.966v69.07h69.237l-69.237-69.07zm13.848 33.384l21.925 21.872H49.76V125.35z",
    fill: "#F05C42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.51 155.28v5.756h-1.5v-5.756h1.5zM55.127 158.158v2.878h-1.5v-2.878h1.5zM64.556 158.158v2.878h-1.5v-2.878h1.5zM73.978 158.158v2.878h-1.5v-2.878h1.5zM59.932 155.28v5.756h-1.5v-5.756h1.5zM69.361 155.28v5.756h-1.5v-5.756h1.5zM41.68 122.647h-5.769v-1.5h5.77v1.5zM38.796 127.252h-2.885v-1.5h2.885v1.5zM38.796 136.653h-2.885v-1.5h2.885v1.5zM38.796 145.862h-2.885v-1.5h2.885v1.5zM41.68 131.856h-5.769v-1.5h5.77v1.5zM41.68 141.258h-5.769v-1.5h5.77v1.5z",
    fill: "#441E80"
  }));
};
project.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var video = function video(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.5 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.423 0 93 41.699 93 93 .121 51.424-41.577 93-93 93z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "25.5",
    y: "50",
    width: "150",
    height: "99",
    rx: "6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 66h-140v78h140V66z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.5 66h-140v78h140V66z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.286 63.185a3.594 3.594 0 1 0 0-7.185 3.594 3.594 0 0 0-3.596 3.593 3.594 3.594 0 0 0 3.596 3.592zM34.095 63.185a3.594 3.594 0 0 0 3.595-3.592A3.594 3.594 0 0 0 34.095 56a3.594 3.594 0 1 0 0 7.185zM60.476 63.185a3.594 3.594 0 0 0 3.595-3.592A3.594 3.594 0 0 0 60.476 56a3.594 3.594 0 1 0 0 7.185z",
    fill: "#FF8267"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 130l105.682.001v4L47.5 134v-4z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 130.084l19.618.002v3l-19.618-.002v-3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5 130.089l19.618.001v4l-19.618-.001v-4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5 138a6 6 0 1 0 0-12 6 6 0 0 0 0 12z",
    fill: "#FD7152"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.426 87.425v25.15L115.234 100 93.426 87.425z",
    fill: "#fff"
  }));
};
video.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var conference = function conference(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.992 150V50L100.138 0 13.283 50v100l86.855 50 86.854-50z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.283 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.125 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.159-29.573 66.159-66.156 0-36.587-29.565-66.156-66.159-66.156-36.594 0-66.158 29.569-66.158 66.156zm-3.842 0c0 38.713 31.287 70 70 70 38.592 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.283 80h-64v76h64V80z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.783 44.682l16.188-8.349-1.375-2.666-17.813 9.186V63h3V44.682z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.057 35.084l-14.279 6.588c-1.892.844-4.3 0-5.16-1.858-.86-1.858 0-4.223 1.892-5.067l14.278-6.419c1.892-.844 4.301 0 5.161 1.858.86 1.858 0 4.054-1.892 4.898z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.283 80l64 22V80h-64z",
    fill: "#FDD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.283 69h-85v11h85V69z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.283 69c0-3.93 4.562-7 10-7 5.439 0 10 3.193 10 7",
    fill: "#E33B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.283 106.303l-11.5-6.678-11.5 6.678v13.394l11.5 6.678 11.5-6.678v-13.394zm4 15.697v-18l-15.5-9-15.5 9v18l15.5 9 15.5-9z",
    fill: "#5320A3"
  }));
};
conference.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var event = function event(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.283 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.424 0 93 41.699 93 93 .122 51.424-41.576 93-93 93z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.283 132.5h96.052V72H31.283v14.005c3.033 0 5.459 2.406 5.459 5.412 0 3.007-2.426 5.412-5.459 5.412v10.824c3.033 0 5.459 2.405 5.459 5.412 0 3.006-2.426 5.412-5.459 5.412V132.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.283 76h-79v52h79V76z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.391 91.11H51.338v4.222h58.053V91.11zM99.891 99.554H60.837v5.278h39.054v-5.278zM109.391 109.054H51.338v4.222h58.053v-4.222z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.46 132.5h-37.847V72h37.847c3.215 0 5.823 2.586 5.823 5.773v48.894a5.812 5.812 0 0 1-5.823 5.833z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.283 128h-4v-6.047h4V128zm0-11.488h-4v-6.047h4v6.047zm0-11.489h-4v-6.046h4v6.046zm0-11.488h-4v-6.047h4v6.047zm0-11.489h-4V76h4v6.046z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.283 82h-2v40h2V82zM151.283 91.524h-2v20h2v-20zM145.283 82h-2v40h2V82z",
    fill: "#fff"
  }));
};
event.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var mediaHighlight = function mediaHighlight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".5",
    d: "M52.812 17l47.529 14.708 47.408-14.707 11.006 48.74 36.523 33.913-36.523 33.912-11.006 48.742-47.408-14.708-47.529 14.708-11.005-48.742L5.283 99.654l36.524-33.912L52.812 17z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.26 0l35.272 38.441 50.594 11.555-15.321 49.995 15.321 49.995-50.594 11.555-35.272 38.44-35.273-38.44-50.704-11.555 15.432-49.995-15.432-49.995L64.987 38.44 100.26.001z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: ".5",
    cx: "99.783",
    cy: "99.501",
    r: "52.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".75",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.33 99.5c0 29.009 23.44 52.452 52.453 52.452 28.921 0 52.454-23.446 52.454-52.451 0-29.009-23.44-52.453-52.454-52.453S47.33 70.492 47.33 99.501zm-3.047 0c0 30.694 24.806 55.5 55.5 55.5 30.598 0 55.5-24.806 55.5-55.5 0-30.693-24.806-55.5-55.5-55.5s-55.5 24.807-55.5 55.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.283 79.677h-56a5 5 0 0 0-5 5v43a5 5 0 0 0 5 5h56a5 5 0 0 0 5-5v-43a5 5 0 0 0-5-5zM167.283 62.677h-52a5 5 0 0 0-5 5v62a5 5 0 0 0 5 5h52a5 5 0 0 0 5-5v-62a5 5 0 0 0-5-5z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "42.892",
    y: "50.286",
    width: "114.102",
    height: "75.307",
    rx: "6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.19 62.457H46.695v59.333H153.19V62.457z",
    fill: "#FDD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.28 78.99c0-5.892 4.52-10.667 10.001-10.667 5.48 0 10 4.775 10 10.666v2.397c0 5.89-4.52 10.667-10 10.667s-10-4.776-10-10.667v-2.397zM99.783 93.994c-8.827 0-15.862 3.44-16 12.183h32c-.138-8.743-7.172-12.183-16-12.183z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.463 60.316a2.734 2.734 0 1 0-2.735-2.733 2.734 2.734 0 0 0 2.735 2.733zM49.43 60.316a2.734 2.734 0 1 0 .002-5.468 2.734 2.734 0 0 0-.002 5.468zM69.497 60.316a2.734 2.734 0 1 0-2.735-2.733 2.734 2.734 0 0 0 2.735 2.733z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.627 111.14l80.389.001v3.043l-80.39-.001v-3.043z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.627 111.208l14.923.001v3.043l-14.923-.001v-3.043z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.122 117.226a4.564 4.564 0 1 0-.001-9.129 4.564 4.564 0 0 0 0 9.129z",
    fill: "#D32859"
  }));
};
mediaHighlight.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var meetup = function meetup(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.154 193.254c-51.302 0-93-41.577-93-93 0-51.424 41.698-93 93-93 51.424 0 93 41.698 93 93 .122 51.423-41.576 93-93 93z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.154 175.254c-41.347 0-75-33.522-75-75 0-41.479 33.522-75 75-75 41.479 0 75 33.521 75 75 0 41.478-33.521 75-75 75z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.61 118.803c7.025 5.362 11.37 7.673 15.16 8.597 3.789.924 7.21.462 12.755-.277h.185c11.092-1.479 24.218 1.941 36.142 11.277 6.841 5.361 13.034 4.714 18.118 4.252l3.05-.277c2.958-.185 6.008.554 8.504 2.033l-4.437-18.302v.185c-2.033 7.579-10.26 12.016-18.394 9.89-8.135-2.218-13.034-10.168-11-17.747 2.033-7.58 10.26-12.017 18.394-9.891 3.236.924 6.009 2.681 8.042 5.084l-8.596-35.403a14.578 14.578 0 0 1-8.689.278c-7.857-2.126-12.571-10.168-10.445-18.025 1.571-5.916 6.47-9.983 12.201-10.815l-4.714-19.227-19.412 20.983c3.051 1.017 5.177 3.79 5.177 7.21 0 .74-.093 1.479-.277 2.126 2.403 1.294 4.067 3.79 4.067 6.748 0 1.94-.74 3.697-1.941 5.084 1.201 1.386 1.941 3.142 1.941 5.084 0 3.327-2.126 6.1-5.084 7.117v.462c0 .463 0 .925-.185 1.387 6.563 2.68 10.26 9.89 8.412 16.916-2.034 7.487-9.799 12.016-17.47 9.983-7.58-2.034-12.11-9.891-10.076-17.47.185-.74.462-1.48.74-2.127H87.5c-2.958 0-5.454-1.663-6.748-4.067-1.294 1.017-2.865 1.572-4.622 1.572-2.958 0-5.453-1.664-6.747-4.16l-1.572 1.664c.093 0 .277 0 .37.092 8.134 2.219 12.94 10.538 10.722 18.672-2.126 8.135-10.537 12.941-18.672 10.815-5.176-1.386-8.966-5.269-10.537-9.983l-6.286 6.84c2.311-.092 4.622.278 6.563.925 2.311.554 4.252 1.479 5.639 2.495zM135.289 163.173l-26.251-7.026 28.47 7.673c2.68.739 4.991.554 6.932-.093-2.68.74-5.915.277-9.151-.554zM44.794 138.954l1.11.278c-4.068-1.11-6.656-2.589-8.32-4.252 1.571 1.756 4.067 3.142 7.21 3.974zM35.458 126.568c.184-.555.37-1.109.462-1.571-.185.554-.37 1.016-.462 1.571z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.994 108.636c-8.134-2.219-16.361 2.218-18.395 9.89-2.033 7.58 2.866 15.529 11 17.748 8.135 2.218 16.361-2.219 18.395-9.891v-.185l-3.05-12.571a15.494 15.494 0 0 0-7.95-4.991zm-11.185 17.193c-.277 1.109-1.479 1.756-2.68 1.479-1.202-.278-1.941-1.479-1.572-2.589.278-1.109 1.479-1.756 2.681-1.479 1.109.278 1.849 1.479 1.571 2.589zm2.311-8.782c-.277 1.109-1.479 1.756-2.68 1.479-1.202-.277-1.941-1.479-1.572-2.588.37-1.109 1.479-1.756 2.681-1.479 1.202.277 1.941 1.479 1.571 2.588zm1.849 4.807c.277-1.109 1.479-1.756 2.681-1.479 1.201.277 1.941 1.479 1.571 2.588-.277 1.109-1.479 1.756-2.681 1.479-1.201-.277-1.941-1.479-1.571-2.588zm4.992 9.983c-.278 1.109-1.479 1.756-2.681 1.479-1.202-.277-1.941-1.479-1.572-2.588.278-1.11 1.479-1.757 2.681-1.479 1.202.277 1.849 1.479 1.572 2.588zm.924-17.748c-.277 1.11-1.479 1.757-2.681 1.479-1.201-.277-1.941-1.479-1.571-2.588.37-1.109 1.479-1.756 2.68-1.479 1.11.277 1.849 1.479 1.572 2.588zm6.47 13.219c-.277 1.109-1.479 1.756-2.68 1.479-1.202-.278-1.941-1.479-1.572-2.589.278-1.109 1.479-1.756 2.681-1.479 1.202.278 1.849 1.479 1.571 2.589zm1.387-8.227c-.277 1.109-1.479 1.756-2.681 1.479-1.201-.278-1.941-1.479-1.571-2.588.277-1.11 1.479-1.757 2.68-1.479 1.202.277 1.849 1.479 1.572 2.588z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.938 131.819c.304-1.134-.409-2.311-1.593-2.628-1.183-.317-2.389.346-2.693 1.48-.304 1.134.409 2.31 1.593 2.627 1.183.317 2.389-.345 2.693-1.479zM121.147 123.24c-1.202-.277-2.403.37-2.681 1.479-.277 1.11.462 2.311 1.572 2.589 1.201.277 2.403-.37 2.68-1.479.37-1.11-.37-2.311-1.571-2.589zM131.221 123.055c.277-1.109-.462-2.31-1.571-2.588-1.109-.277-2.404.37-2.681 1.479-.277 1.109.462 2.311 1.572 2.588 1.109.278 2.403-.369 2.68-1.479zM139.172 116.493c-1.202-.278-2.404.369-2.681 1.479-.277 1.109.462 2.31 1.571 2.588 1.202.277 2.404-.37 2.681-1.479.277-1.109-.37-2.311-1.571-2.588zM123.552 114.459c-1.202-.277-2.404.37-2.681 1.479-.277 1.109.462 2.311 1.571 2.588 1.11.277 2.404-.37 2.681-1.479.37-1.109-.37-2.311-1.571-2.588zM131.221 111.501c-1.202-.277-2.404.37-2.681 1.479-.277 1.109.462 2.311 1.571 2.588 1.202.277 2.404-.37 2.681-1.479.37-1.109-.37-2.311-1.571-2.588zM139.279 127.36c.304-1.134-.409-2.311-1.593-2.628-1.183-.317-2.389.345-2.693 1.479-.304 1.135.409 2.311 1.593 2.628 1.183.317 2.389-.345 2.693-1.479z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.325 118.434c8.134 2.218 16.453-2.681 18.672-10.815 2.218-8.135-2.68-16.454-10.723-18.672-.092 0-.277-.093-.37-.093l-2.865 3.143c.185 0 .37 0 .462.093 1.202.277 1.941 1.571 1.572 2.773-.278 1.201-1.572 1.848-2.773 1.571-.925-.277-1.572-1.017-1.664-1.941l-3.513 3.79c-.185.554-.647 1.017-1.201 1.294l-8.227 8.874c1.664 4.714 5.453 8.596 10.63 9.983zm10.26-19.597c.278-1.201 1.572-1.94 2.773-1.571 1.202.37 1.941 1.571 1.572 2.773-.37 1.202-1.572 1.941-2.773 1.571-1.202-.369-1.85-1.571-1.572-2.773zm-1.571 8.874c.277-1.201 1.571-1.941 2.773-1.571 1.202.37 1.941 1.571 1.571 2.773-.37 1.202-1.571 1.941-2.773 1.571-1.201-.369-1.94-1.571-1.571-2.773zm-3.235 6.009c-.278 1.201-1.572 1.941-2.773 1.571-1.202-.37-1.942-1.571-1.572-2.773.277-1.202 1.572-1.941 2.773-1.572 1.202.37 1.941 1.664 1.572 2.774zm-4.807-10.538c.277-1.202 1.571-1.941 2.773-1.572 1.202.37 1.941 1.572 1.571 2.774-.37 1.201-1.571 1.941-2.773 1.571-1.201-.277-1.94-1.571-1.571-2.773zm-8.504 3.143c.277-1.202 1.571-1.941 2.773-1.572 1.202.37 1.941 1.572 1.571 2.773-.37 1.202-1.571 1.941-2.773 1.572-1.201-.37-1.94-1.572-1.571-2.773z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.526 112.61c-.277 1.202.37 2.404 1.571 2.773 1.202.37 2.404-.369 2.774-1.571.277-1.202-.37-2.403-1.572-2.773-1.202-.37-2.496.37-2.773 1.571zM56.72 107.434c.277-1.202-.37-2.403-1.572-2.773-1.201-.37-2.403.37-2.773 1.571-.37 1.202.37 2.404 1.572 2.773 1.201.37 2.496-.369 2.773-1.571zM62.54 105.955c1.202.277 2.404-.37 2.774-1.571.37-1.202-.37-2.404-1.572-2.774-1.201-.369-2.403.37-2.773 1.572-.37 1.202.37 2.496 1.572 2.773zM72.157 101.61c1.201.278 2.403-.369 2.773-1.571.37-1.202-.37-2.403-1.572-2.773-1.201-.37-2.403.37-2.773 1.571-.277 1.202.37 2.496 1.572 2.773zM59.215 98.283l-1.201 1.294c.554-.277.924-.647 1.201-1.294zM64.3 96.434c1.201.277 2.403-.37 2.773-1.571.37-1.202-.37-2.404-1.572-2.773-.185 0-.37-.093-.462-.093l-2.403 2.496c.092.924.74 1.664 1.664 1.941zM70.585 110.392c1.202.277 2.404-.37 2.774-1.572.37-1.201-.37-2.403-1.572-2.773-1.202-.369-2.403.37-2.773 1.572-.37 1.201.37 2.495 1.572 2.773z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.112 113.535c7.672 2.033 15.437-2.496 17.563-10.076 1.848-7.025-1.849-14.235-8.412-16.916a7.739 7.739 0 0 1-2.773 4.53c0 .092 0 .277-.093.37-.277 1.109-1.479 1.756-2.588 1.478-.277-.092-.554-.184-.739-.37-.462.093-.832.093-1.294.093-1.941 0-3.79-.74-5.084-2.033-1.294 1.848-3.42 3.142-5.916 3.235a14.371 14.371 0 0 0-.74 2.126c-2.033 7.672 2.496 15.529 10.076 17.563zm9.613-18.395c.277-1.11 1.479-1.756 2.588-1.479 1.11.277 1.757 1.479 1.479 2.588-.277 1.11-1.479 1.757-2.588 1.48-1.109-.278-1.756-1.48-1.479-2.589zm-1.479 8.319c.277-1.109 1.479-1.756 2.588-1.479 1.11.278 1.757 1.479 1.479 2.588-.277 1.11-1.479 1.757-2.588 1.479-1.109-.369-1.756-1.479-1.479-2.588zm-2.958 5.639c-.277 1.109-1.479 1.756-2.588 1.479-1.11-.278-1.756-1.479-1.479-2.588.277-1.11 1.479-1.757 2.588-1.479 1.109.369 1.757 1.479 1.479 2.588zm-4.53-9.89c.278-1.11 1.48-1.757 2.589-1.48 1.109.278 1.756 1.48 1.479 2.588-.277 1.11-1.479 1.757-2.588 1.479-1.11-.277-1.849-1.386-1.48-2.588zm-5.73-5.824c.277-1.11 1.479-1.757 2.588-1.48 1.11.278 1.756 1.48 1.479 2.589-.277 1.11-1.479 1.756-2.588 1.479-1.11-.277-1.756-1.48-1.48-2.588zm-2.311 8.781c.277-1.109 1.479-1.756 2.588-1.479 1.11.277 1.756 1.479 1.48 2.588-.278 1.11-1.48 1.757-2.59 1.479-1.108-.277-1.755-1.479-1.478-2.588z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.222 108.081c-.277 1.109.37 2.218 1.48 2.588 1.108.37 2.218-.37 2.587-1.479.278-1.109-.369-2.218-1.479-2.588-1.109-.37-2.218.37-2.588 1.479zM91.198 104.753c1.109.278 2.218-.369 2.588-1.479.277-1.109-.37-2.218-1.479-2.588-1.11-.37-2.218.37-2.588 1.479-.277 1.109.37 2.219 1.479 2.588zM99.239 101.795c1.109.278 2.218-.369 2.588-1.479.277-1.109-.37-2.218-1.479-2.588-1.11-.277-2.219.37-2.588 1.48-.37 1.201.37 2.31 1.479 2.587zM108.205 97.728c1.109.277 2.218-.37 2.588-1.479.277-1.11-.37-2.218-1.479-2.588-1.109-.277-2.219.37-2.588 1.479-.278 1.11.369 2.31 1.479 2.588zM93.509 95.972c1.11.277 2.218-.37 2.588-1.48.277-1.108-.37-2.218-1.479-2.587-1.11-.278-2.218.37-2.588 1.479-.277 1.109.37 2.31 1.479 2.588zM103.397 91.442c0-.092.093-.277.093-.37-.925.74-2.126 1.295-3.328 1.48.185.185.462.277.74.37 1.109.277 2.218-.37 2.495-1.48zM106.728 105.955c1.109.277 2.219-.37 2.588-1.479.278-1.109-.369-2.218-1.479-2.588-1.109-.278-2.218.37-2.588 1.479-.277 1.201.37 2.311 1.479 2.588z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.307 60.477c-2.126 7.857 2.588 15.991 10.445 18.025 2.958.832 5.916.647 8.689-.278l-5.176-21.168c-.925-.462-1.479-1.478-1.202-2.588.092-.277.185-.554.37-.832l-1.017-4.067c-5.639.925-10.538 4.992-12.109 10.908zm15.806 13.495c-.277 1.11-1.479 1.849-2.68 1.572-1.11-.278-1.849-1.48-1.572-2.681.278-1.11 1.479-1.849 2.681-1.571 1.202.37 1.849 1.571 1.571 2.68zm-4.714-10.168c.277-1.109 1.479-1.848 2.681-1.571 1.109.277 1.848 1.479 1.571 2.68-.277 1.11-1.479 1.85-2.681 1.572-1.201-.37-1.941-1.571-1.571-2.68zm-5.916-6.1c.278-1.11 1.479-1.85 2.681-1.572 1.109.278 1.849 1.48 1.571 2.68-.277 1.11-1.479 1.85-2.68 1.572-1.202-.277-1.849-1.479-1.572-2.68zm.278 7.58c1.109.277 1.848 1.478 1.571 2.68-.277 1.202-1.479 1.849-2.681 1.571-1.109-.277-1.848-1.479-1.571-2.68.37-1.202 1.479-1.941 2.681-1.572z",
    fill: "#D32859"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.863 72.863c-.278 1.11.369 2.31 1.571 2.68 1.109.278 2.311-.37 2.681-1.57.277-1.11-.37-2.312-1.572-2.681-1.109-.278-2.311.462-2.68 1.571zM120.248 69.152a2.126 2.126 0 1 0-2.126-3.682 2.126 2.126 0 0 0 2.126 3.682zM126.876 66.392c1.109.278 2.311-.37 2.681-1.57.277-1.11-.37-2.312-1.572-2.681-1.109-.278-2.311.37-2.68 1.57-.278 1.203.462 2.404 1.571 2.681zM121.054 60.384c1.109.277 2.31-.37 2.68-1.571.277-1.11-.37-2.311-1.571-2.68-1.109-.278-2.311.369-2.681 1.57-.277 1.202.37 2.404 1.572 2.681zM128.264 57.057l-.832-3.328c-.185.185-.37.462-.37.832-.277 1.017.277 2.126 1.202 2.496z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.459 126.568c-.185.647-.37 1.387-.463 2.034-.184 1.479.185 3.882 2.589 6.285-2.219-2.311-2.958-5.176-2.126-8.319zM150.82 155.685c-.74 3.605-2.866 6.563-6.101 7.857 2.126-.739 3.975-2.218 5.177-4.991 0-.093.092-.185.092-.185.277-.647.462-1.202.647-1.849v-.092l.185-.74zM36.847 123.148l-.278.462c0-.092.093-.277.278-.462 0 .092 0 0 0 0z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.474 123.61l-.555 1.387c.185-.555.555-1.202.832-1.757-.092.093-.184.278-.277.37z",
    fill: "#441E80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.248 150.232c-1.757-2.034-4.807-3.328-8.042-3.143-.74 0-1.479.092-2.403.185-5.084.554-13.311 1.479-21.723-5.177-11-8.689-23.016-11.647-32.63-10.353l-.37.093c-5.268.739-9.52 1.294-14.234.092-4.807-1.109-9.706-3.974-16.916-9.428-.74-.555-2.218-1.294-3.975-1.849-1.849-.554-3.79-.832-5.73-.647-1.942.185-3.606.74-4.992 1.941-.462.37-.832.832-1.202 1.294-.37.647-.647 1.202-.832 1.757a7.795 7.795 0 0 0-.462 1.571c-.74 3.143-.093 6.008 2.033 8.319 0 0 0 .093.093.093 1.664 1.571 4.252 3.143 8.32 4.252l62.855 16.915 26.252 7.026c3.143.831 6.47 1.294 9.151.462.093 0 .185 0 .185-.093 3.235-1.294 5.361-4.252 6.101-7.949v-.185c.369-2.034-.278-3.882-1.479-5.176z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.633 60.661l-12.94-14.79-8.135 14.051 6.563 3.79c3.605 2.034 11.185-1.202 14.512-3.05zM86.577 56.687c-.37-.647-2.403-14.975-4.252-24.218 0 0-7.487 2.218-11.555 7.21l6.656 13.957 9.151 3.05zM67.347 74.065l-8.134-2.126-14.512 5.36c-.925 4.715 2.403 9.244 2.403 9.244 7.765-4.621 19.504-12.201 20.243-12.478z",
    fill: "#fff"
  }));
};
meetup.defaultProps = {
  width: "201",
  height: "201",
  viewBox: "0 0 201 201",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var membership = function membership(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    d: "M100.283 193c-51.302 0-93-41.576-93-93 0-51.423 41.698-93 93-93 51.424 0 93 41.699 93 93 .122 51.424-41.576 93-93 93z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.283 175c-41.348 0-75-33.521-75-75 0-41.478 33.522-75 75-75s75 33.522 75 75c0 41.479-33.522 75-75 75z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.283 133.895V66.808c0-3.088 2.85-5.614 6.334-5.614h110.848c3.484 0 6.334 2.526 6.334 5.614v67.227c0 3.088-2.85 5.614-6.334 5.614H44.617c-3.483-.14-6.334-2.667-6.334-5.754z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.283 68V46.897c0-1.593 1.181-2.897 2.625-2.897h13.126c1.443 0 2.625 1.304 2.625 2.897V68H91.283z",
    fill: "#FDD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.388 84.323h40.628v4h-40.628v-4zM107.388 93.55h26.162v4h-26.162v-4zM107.388 102.931h34.011v4h-34.011v-4zM107.283 112h24.777v4h-24.777v-4z",
    fill: "#FFE0D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.765 77.168h-45.29v46.318h45.29V77.168z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "65.58",
    y: "85.169",
    width: "17.081",
    height: "20.761",
    rx: "8.541",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.12 107.336c-9.087 0-16.328 3.4-16.47 12.039h32.94c-.142-8.639-7.383-12.039-16.47-12.039z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.089 71.912l11.494 2.813-4.88-10.763 6.02-10.168-11.537 1.286-7.94-8.708-2.169 11.416-10.634 4.656 10.298 5.795 1.043 11.696 8.305-8.023z",
    fill: "#fff"
  }));
};
membership.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var presentation = function presentation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M186.992 150V50L100.138 0 13.283 50v100l86.855 50 86.854-50z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M100.283 170c-38.713 0-70-31.287-70-70s31.287-70 70-70 70 31.287 70 70-31.287 70-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.125 100c0 36.587 29.564 66.156 66.158 66.156 36.477 0 66.159-29.573 66.159-66.156 0-36.587-29.565-66.156-66.159-66.156-36.594 0-66.158 29.569-66.158 66.156zm-3.842 0c0 38.713 31.287 70 70 70 38.592 0 70-31.287 70-70s-31.287-70-70-70-70 31.287-70 70z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.562 54.57H31.038v89.112h134.524V54.57z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3 143.682h-126v5h126v-5z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.22 81.443c-10.137 0-18.364 8.25-18.364 18.416h-7.64c0-14.438 11.607-26.078 26.005-26.078v7.662z",
    fill: "#F75183"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.703 96.091h-7.64c0-10.166-8.227-18.416-18.365-18.416v-7.662c14.251 0 26.005 11.64 26.005 26.078z",
    fill: "#FDD4E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.228 71.071h-29.582v7.48h29.582v-7.48zM165.561 84.6h-22.042v6.99h22.042V84.6zM156.775 97.64h-14.66v6.988h14.66v-6.989zM149.445 109.909h-7.383v6.989h7.383v-6.989z",
    fill: "#E33B6B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.25 103.471H35.3l-.002-5.003h28.95l.001 5.003zM64.249 90.773H35.308V84.6h28.941v6.174zM65.298 73.781H35.3v-7.536h29.997v7.536zM65.298 49.839H35.3v-7.536h29.997v7.536zM64.243 113.404H35.3v-4.232h28.942v4.232z",
    fill: "#5320A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.573 116.429c9.12 0 16.522-7.423 16.522-16.57h6.874c0 12.991-10.575 23.462-23.528 23.462-12.938 0-23.371-10.446-23.396-23.415l6.873-.016c.017 9.132 7.545 16.539 16.655 16.539z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44 118.276c10.138 0 18.366-8.251 18.366-18.417h7.639c0 14.439-11.753 26.078-26.151 26.078-14.38 0-25.977-11.611-26.004-26.026l7.64-.018c.018 10.151 8.385 18.383 18.51 18.383z",
    fill: "#F75183"
  }));
};
presentation.defaultProps = {
  width: "201",
  height: "200",
  viewBox: "0 0 201 200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var competitionPlaceholder = function competitionPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.143-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#fff3d5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#FFE29B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
competitionPlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
var educationPlaceholder = function educationPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.142-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#e7d9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#C7A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
educationPlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
var employmentPlaceholder = function employmentPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.143-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#bff5fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#66E8F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
employmentPlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
var lifePlaceholder = function lifePlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.143-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#d0f6e9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#8FEBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
lifePlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
var personalPlaceholder = function personalPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.143-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#ffe0d9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#FFB4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
personalPlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
var socialPlaceholder = function socialPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M40.203 7.313l5.677-3.125 4.31 4.738 6.336-1.21 2.686 5.848 6.388.806.76 6.402 5.83 2.722-1.318 6.25 4.714 4.385-3.193 5.595 3.142 5.646-4.765 4.284 1.217 6.3-5.88 2.672-.811 6.351-6.388.756-2.737 5.797-6.337-1.31-4.41 4.687-5.627-3.175-5.627 3.125-4.36-4.738-6.336 1.21-2.686-5.848-6.388-.806-.71-6.351-5.88-2.722 1.318-6.3-4.714-4.386 3.193-5.595-3.143-5.595L9.23 29.39l-1.217-6.3 5.88-2.672.811-6.351 6.438-.706 2.738-5.847 6.286 1.31 4.41-4.687 5.627 3.175z",
    fill: "#fdd4e0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.137 17.878l3.829-2.12 2.906 3.214 4.273-.82 1.812 3.965 4.308.547.513 4.342 3.931 1.846-.889 4.24L64 36.066l-2.154 3.795 2.12 3.829-3.214 2.906.82 4.273-3.965 1.812-.547 4.308-4.308.513-1.846 3.931-4.273-.888-2.975 3.18-3.795-2.155-3.795 2.12-2.94-3.214-4.273.82-1.812-3.965-4.308-.547-.479-4.308-3.965-1.846.889-4.273L16 43.382l2.154-3.795-2.12-3.795 3.214-2.94-.82-4.273 3.965-1.812.547-4.308 4.342-.479 1.846-3.965 4.24.889 2.974-3.18 3.795 2.154z",
    fill: "#FF8BAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.965 26.593c-3.808 0-6.432 2.015-7.488 4.8l3.296 1.824c.8-2.016 2.4-3.04 4.16-3.04 1.888 0 3.232 1.247 3.232 2.944 0 1.183-.832 2.495-2.496 3.968l-.864.736c-1.92 1.663-2.688 3.167-2.688 5.375v1.44h3.68v-.767c0-1.633.672-2.529 2.432-4.032 1.44-1.248 2.464-2.305 3.104-3.2.64-.896.96-1.984.96-3.297 0-1.952-.704-3.584-2.112-4.832-1.376-1.28-3.136-1.92-5.216-1.92zM39.1 52.224c1.408 0 2.528-1.087 2.528-2.495A2.533 2.533 0 0 0 39.1 47.2c-1.376 0-2.496 1.12-2.496 2.528a2.479 2.479 0 0 0 2.496 2.496z",
    fill: "#fff"
  }));
};
socialPlaceholder.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 80 80",
  fill: "none"
};
export const BadgePlaceholders = {
  Competition: competitionPlaceholder,
  Education: educationPlaceholder,
  Employment: employmentPlaceholder,
  Life: lifePlaceholder,
  Personal: personalPlaceholder,
  Social: socialPlaceholder
};
export const Badges = {
  // Competition
  award,
  challenge,
  hackathon,
  honor,
  paddlGames,
  prize,
  tournament,
  // Education
  bachelorDegree,
  certificate,
  course,
  diploma,
  doctorate,
  phd,
  highSchool,
  masterDegree,
  workshop,
  // Employment
  boardMember,
  casualWork,
  contract,
  entrepreneur,
  founder,
  fullTime,
  internship,
  partTime,
  sideHustle,
  // Life
  exercise,
  hobby,
  home,
  mentoring,
  travel,
  volunteer,
  // Personal
  article,
  book,
  podcast,
  project,
  video,
  // Social
  conference,
  event,
  mediaHighlight,
  meetup,
  membership,
  presentation
};
export const badgesMetadata = {
  // Competition
  award: {
    category: 'Competition',
    name: 'Award',
    description: ''
  },
  challenge: {
    category: 'Competition',
    name: 'Challenge',
    description: ''
  },
  hackathon: {
    category: 'Competition',
    name: 'Hackathon',
    description: 'Team problem solving challenge.'
  },
  honor: {
    category: 'Competition',
    name: 'Honor',
    description: ''
  },
  paddlGames: {
    category: 'Competition',
    name: 'Paddl Games',
    description: 'Cross functional innovation challenge.'
  },
  prize: {
    category: 'Competition',
    name: 'Prize',
    description: 'Special commendation from an authority.'
  },
  tournament: {
    category: 'Competition',
    name: 'Tournament',
    description: ''
  },
  // Education
  bachelorDegree: {
    category: 'Education',
    name: 'Bachelor Degree',
    description: 'Undergraduate, awarded by an Academic Organisation'
  },
  certificate: {
    category: 'Education',
    name: 'Certificate',
    description: 'Certification from a registered training organisation.'
  },
  course: {
    category: 'Education',
    name: 'Course',
    description: 'Learning module, online or offline, short or long.'
  },
  diploma: {
    category: 'Education',
    name: 'Diploma',
    description: 'An offical academic course of study.'
  },
  doctorate: {
    category: 'Education',
    name: 'Doctorate',
    description: ''
  },
  phd: {
    category: 'Education',
    name: 'PhD',
    description: 'Doctor of Philosophy, advanced research thesis.'
  },
  highSchool: {
    category: 'Education',
    name: 'High School',
    description: 'Final years of secondary education.'
  },
  masterDegree: {
    category: 'Education',
    name: 'Master Degree',
    description: 'Academic high-order in a field of study.'
  },
  workshop: {
    category: 'Education',
    name: 'Workshop',
    description: 'Instructor led, interactive tutorial or class.'
  },
  // Employment
  boardMember: {
    category: 'Employment',
    name: 'Board Member',
    description: ''
  },
  casualWork: {
    category: 'Employment',
    name: 'Casual Work',
    description: 'Job without a fixed term or hours.'
  },
  contract: {
    category: 'Employment',
    name: 'Contract',
    description: 'Fixed term of employment as an independent worker.'
  },
  entrepreneur: {
    category: 'Employment',
    name: 'Entrepreneur',
    description: ''
  },
  founder: {
    category: 'Employment',
    name: 'Founder',
    description: ''
  },
  fullTime: {
    category: 'Employment',
    name: 'Full-time',
    description: 'Permanent role with benefits as an employee.'
  },
  internship: {
    category: 'Employment',
    name: 'Internship',
    description: 'Short term work experience as a trainee.'
  },
  partTime: {
    category: 'Employment',
    name: 'Part-time',
    description: 'Reduced or fixed hours as a permanent employee.'
  },
  sideHustle: {
    category: 'Employment',
    name: 'Side Hustle',
    description: 'A job or project for extra income on the side.'
  },
  // Life
  exercise: {
    category: 'Life',
    name: 'Exercise',
    description: ''
  },
  hobby: {
    category: 'Life',
    name: 'Hobby',
    description: ''
  },
  home: {
    category: 'Life',
    name: 'Home',
    description: ''
  },
  mentoring: {
    category: 'Life',
    name: 'Mentoring',
    description: ''
  },
  travel: {
    category: 'Life',
    name: 'Travel',
    description: ''
  },
  volunteer: {
    category: 'Life',
    name: 'Volunteer',
    description: 'Unpaid support for a cause or community.'
  },
  // Personal
  article: {
    category: 'Personal',
    name: 'Article',
    description: 'News, blog or short reading material.'
  },
  book: {
    category: 'Personal',
    name: 'Book',
    description: ''
  },
  podcast: {
    category: 'Personal',
    name: 'Podcast',
    description: ''
  },
  project: {
    category: 'Personal',
    name: 'Project',
    description: ''
  },
  video: {
    category: 'Personal',
    name: 'Video',
    description: 'Tutorial, talk or opinion piece, pre-recorded or live.'
  },
  // Social
  conference: {
    category: 'Social',
    name: 'Conference',
    description: ''
  },
  event: {
    category: 'Social',
    name: 'Event',
    description: ''
  },
  mediaHighlight: {
    category: 'Social',
    name: 'Media Highlight',
    description: ''
  },
  meetup: {
    category: 'Social',
    name: 'Meetup',
    description: 'A get together for a shared interest group.'
  },
  membership: {
    category: 'Social',
    name: 'Membership',
    description: 'Part of a club, society, interest group or subscription list.'
  },
  presentation: {
    category: 'Social',
    name: 'Presentation',
    description: ''
  }
};